/* Rule Id: 1519541 */
/* Copyright (c) 2016 comScore, Inc.
 * All rights reserved.
 * By using this software, you are agreeing to be bound by the
 * terms of these policies: http://www.comscore.com/About_comScore/Privacy_Policy
 */
! function(a, b) {
  "function" == typeof define && define.amd ? define([], function() {
    return a.ns_ = b(a.ns_)
  }) : "object" == typeof module && module.exports ? module.exports = b() : a.ns_ = b(a.ns_)
}(window, function(a) {
  a = a || {}, a.ns_ = a;
  var b = {
    uid: function() {
      var a = 1;
      return function() {
        return +new Date + "_" + a++
      }
    }(),
    filter: function(a, b) {
      var c = {};
      for (var d in b) b.hasOwnProperty(d) && a(b[d]) && (c[d] = b[d]);
      return c
    },
    extend: function(a) {
      var b, c = arguments.length;
      a = a || {};
      for (var d = 1; c > d; d++)
        if (b = arguments[d])
          for (var e in b) b.hasOwnProperty(e) && (a[e] = b[e]);
      return a
    },
    getString: function(a, b) {
      var c = String(a);
      return null == a ? b || "na" : c
    },
    getLong: function(a, b) {
      var c = Number(a);
      return null == a || isNaN(c) ? b || 0 : c
    },
    getInteger: function(a, b) {
      var c = Number(parseInt(a));
      return null == a || isNaN(c) ? b || 0 : c
    },
    getBoolean: function(a, b) {
      var c = "true" == String(a).toLowerCase();
      return null == a ? b || !1 : c
    },
    parseBoolean: function(a, b) {
      return b = b || !1, a ? "0" == a ? !1 : void 0 : b
    },
    isNotEmpty: function(a) {
      return !this.isEmpty(a)
    },
    isEmpty: function(a) {
      return void 0 === a || null === a || "" === a || a instanceof Array && 0 === a.length
    },
    indexOf: function(a, b) {
      var c = -1;
      return this.forEach(b, function(b, d) {
        b == a && (c = d)
      }), c
    },
    forEach: function(a, b, c) {
      try {
        if ("function" == typeof b)
          if (c = "undefined" != typeof c ? c : null, "number" != typeof a.length || "undefined" == typeof a[0]) {
            var d = "undefined" != typeof a.__proto__;
            for (var e in a) a.hasOwnProperty(e) && (!d || d && "undefined" == typeof a.__proto__[e]) && "function" != typeof a[e] && b.call(c, a[e], e)
          } else
            for (var f = 0, g = a.length; g > f; f++) b.call(c, a[f], f)
      } catch (h) {}
    },
    regionMatches: function(a, b, c, d, e) {
      if (0 > b || 0 > d || b + e > a.length || d + e > c.length) return !1;
      for (; --e >= 0;) {
        var f = a.charAt(b++),
          g = c.charAt(d++);
        if (f != g) return !1
      }
      return !0
    },
    size: function(a) {
      var b = 0;
      for (var c in a) a.hasOwnProperty(c) && b++;
      return b
    },
    log: function(a, b) {
      if ("undefined" != typeof b && b && "undefined" != typeof console && console) {
        var c = new Date,
          d = c.getHours() + ":" + c.getMinutes() + ":" + c.getSeconds();
        console.log(d, a)
      }
    },
    isTrue: function(a) {
      return "undefined" == typeof a ? !1 : "string" == typeof a ? (a = a.toLowerCase(), "true" === a || "1" === a || "on" === a) : !!a
    },
    toString: function(a) {
      if ("undefined" == typeof a) return "undefined";
      if ("string" == typeof a) return a;
      if ("[object Array]" === Object.prototype.toString.call(a)) return a.join(",");
      if (this.size(a) > 0) {
        var b = "";
        for (var c in a) a.hasOwnProperty(c) && (b += c + ":" + a[c] + ";");
        return b
      }
      return a.toString()
    },
    exists: function(a) {
      return "undefined" != typeof a && null != a
    },
    firstGreaterThan0: function() {
      for (var a = 0, b = arguments.length; b > a; a++) {
        var c = arguments[a];
        if (c > 0) return c
      }
      return 0
    },
    cloneObject: function(a) {
      if (null == a || "object" != typeof a) return a;
      var b = function() {
        function a() {}

        function b(b) {
          return "object" == typeof b ? (a.prototype = b, new a) : b
        }

        function c(a) {
          for (var b in a) a.hasOwnProperty(b) && (this[b] = a[b])
        }

        function d() {
          this.copiedObjects = [];
          var a = this;
          this.recursiveDeepCopy = function(b) {
            return a.deepCopy(b)
          }, this.depth = 0
        }

        function e(a, b) {
          var c = new d;
          return b && (c.maxDepth = b), c.deepCopy(a)
        }

        function f(a) {
          return "undefined" != typeof window && window && window.Node ? a instanceof Node : "undefined" != typeof document && a === document ? !0 : "number" == typeof a.nodeType && a.attributes && a.childNodes && a.cloneNode
        }
        var g = [];
        return c.prototype = {
          constructor: c,
          canCopy: function() {
            return !1
          },
          create: function(a) {},
          populate: function(a, b, c) {}
        }, d.prototype = {
          constructor: d,
          maxDepth: 256,
          cacheResult: function(a, b) {
            this.copiedObjects.push([a, b])
          },
          getCachedResult: function(a) {
            for (var b = this.copiedObjects, c = b.length, d = 0; c > d; d++)
              if (b[d][0] === a) return b[d][1]
          },
          deepCopy: function(a) {
            if (null === a) return null;
            if ("object" != typeof a) return a;
            var b = this.getCachedResult(a);
            if (b) return b;
            for (var c = 0; c < g.length; c++) {
              var d = g[c];
              if (d.canCopy(a)) return this.applyDeepCopier(d, a)
            }
            throw new Error("Unable to clone the following object " + a)
          },
          applyDeepCopier: function(a, b) {
            var c = a.create(b);
            if (this.cacheResult(b, c), this.depth++, this.depth > this.maxDepth) throw new Error("Maximum recursion depth exceeded.");
            return a.populate(this.recursiveDeepCopy, b, c), this.depth--, c
          }
        }, e.DeepCopier = c, e.deepCopiers = g, e.register = function(a) {
          a instanceof c || (a = new c(a)), g.unshift(a)
        }, e.register({
          canCopy: function() {
            return !0
          },
          create: function(a) {
            return a instanceof a.constructor ? b(a.constructor.prototype) : {}
          },
          populate: function(a, b, c) {
            for (var d in b) b.hasOwnProperty(d) && (c[d] = a(b[d]));
            return c
          }
        }), e.register({
          canCopy: function(a) {
            return a instanceof Array
          },
          create: function(a) {
            return new a.constructor
          },
          populate: function(a, b, c) {
            for (var d = 0; d < b.length; d++) c.push(a(b[d]));
            return c
          }
        }), e.register({
          canCopy: function(a) {
            return a instanceof Date
          },
          create: function(a) {
            return new Date(a)
          }
        }), e.register({
          canCopy: function(a) {
            return f(a)
          },
          create: function(a) {
            return "undefined" != typeof document && a === document ? document : a.cloneNode(!1)
          },
          populate: function(a, b, c) {
            if ("undefined" != typeof document && b === document) return document;
            if (b.childNodes && b.childNodes.length)
              for (var d = 0; d < b.childNodes.length; d++) {
                var e = a(b.childNodes[d]);
                c.appendChild(e)
              }
          }
        }), {
          deepCopy: e
        }
      }();
      return b.deepCopy(a)
    },
    safeGet: function(a, b) {
      return b = this.exists(b) ? b : "", this.exists(a) ? a : b
    },
    getBrowserName: function() {
      if (!navigator) return "";
      var a, b, c = navigator.userAgent || "",
        d = navigator.appName || "";
      return -1 != (b = c.indexOf("Opera")) || -1 != (b = c.indexOf("OPR/")) ? d = "Opera" : -1 != (b = c.indexOf("Android")) ? d = "Android" : -1 != (b = c.indexOf("Chrome")) ? d = "Chrome" : -1 != (b = c.indexOf("Safari")) ? d = "Safari" : -1 != (b = c.indexOf("Firefox")) ? d = "Firefox" : -1 != (b = c.indexOf("IEMobile")) ? d = "Internet Explorer Mobile" : "Microsoft Internet Explorer" == d || "Netscape" == d ? d = "Internet Explorer" : (a = c.lastIndexOf(" ") + 1) < (b = c.lastIndexOf("/")) ? (d = c.substring(a, b), d.toLowerCase() == d.toUpperCase() && (d = navigator.appName)) : d = "unknown", d
    },
    getBrowserFullVersion: function() {
      if (!navigator) return "";
      var a, b, c, d, e = navigator.userAgent || "",
        f = navigator.appName || "",
        g = navigator.appVersion ? "" + parseFloat(navigator.appVersion) : "";
      return -1 != (b = e.indexOf("Opera")) ? (g = e.substring(b + 6), -1 != (b = e.indexOf("Version")) && (g = e.substring(b + 8))) : -1 != (b = e.indexOf("OPR/")) ? g = e.substring(b + 4) : -1 != (b = e.indexOf("Android")) ? g = e.substring(b + 11) : -1 != (b = e.indexOf("Chrome")) ? g = e.substring(b + 7) : -1 != (b = e.indexOf("Safari")) ? (g = e.substring(b + 7), -1 != (b = e.indexOf("Version")) && (g = e.substring(b + 8))) : -1 != (b = e.indexOf("Firefox")) ? g = e.substring(b + 8) : "Microsoft Internet Explorer" == f ? (d = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : "Netscape" == f ? (d = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : g = e.lastIndexOf(" ") + 1 < (b = e.lastIndexOf("/")) ? e.substring(b + 1) : "unknown", g = g.toString(), -1 != (c = g.indexOf(";")) && (g = g.substring(0, c)), -1 != (c = g.indexOf(" ")) && (g = g.substring(0, c)), -1 != (c = g.indexOf(")")) && (g = g.substring(0, c)), a = parseInt("" + g, 10), isNaN(a) && (g = "" + parseFloat(navigator.appVersion)), g
    },
    browserAcceptsLargeURLs: function() {
      return "undefined" != typeof window ? (null !== window.ActiveXObject, !0) : !0
    },
    getNamespace: function() {
      return a.ns_ || a
    }
  };
  return a.StreamSense = a.StreamSense || function() {
    var c = function() {
        var a = "cs_";
        return function() {
          var c = "undefined" != typeof localStorage ? localStorage : null;
          b.extend(this, {
            get: function(b) {
              return c && c.getItem(a + b)
            },
            set: function(b, d) {
              c && c.setItem(a + b, d)
            },
            has: function(b) {
              return c && c.getItem(a + b)
            },
            remove: function(b) {
              c && c.removeItem(a + b)
            },
            clear: function() {
              for (var b = 0; c && b < c.length; ++b) {
                var d = c.key(b);
                d.substr(0, a.length) === a && c.removeItem(d)
              }
            }
          })
        }
      }(),
      d = function(a, b) {
        if ("undefined" != typeof Image) {
          var c = new Image;
          c.onload = function() {
            b && b(200), c = null
          }, c.onerror = function() {
            b && b(), c = null
          }, c.src = a
        }
      },
      e = function(a, b, c) {
        c && "undefined" != typeof setTimeout && setTimeout(c, 0)
      },
      f = function() {
        return {
          dir: function() {
            return null
          },
          append: function(a, b, c) {},
          write: function(a, b, c) {},
          deleteFile: function() {
            return !1
          },
          read: function() {
            return null
          }
        }
      }(),
      g = function() {
        return {
          PLATFORM: "generic",
          httpGet: d,
          httpPost: e,
          Storage: c,
          IO: f,
          getCrossPublisherId: function() {
            return null
          },
          getAppName: function() {
            return h.UNKNOWN_VALUE
          },
          getAppVersion: function() {
            return h.UNKNOWN_VALUE
          },
          getVisitorId: function() {
            return this.getDeviceName() + +new Date + ~~(1e3 * Math.random())
          },
          getVisitorIdSuffix: function() {
            return "72"
          },
          getDeviceName: function() {
            return h.UNKNOWN_VALUE
          },
          getPlatformVersion: function() {
            return h.UNKNOWN_VALUE
          },
          getPlatformName: function() {
            return "js"
          },
          getRuntimeName: function() {
            return h.UNKNOWN_VALUE
          },
          getRuntimeVersion: function() {
            return h.UNKNOWN_VALUE
          },
          getResolution: function() {
            return h.UNKNOWN_VALUE
          },
          getLanguage: function() {
            return h.UNKNOWN_VALUE
          },
          getPackageName: function() {
            return null
          },
          isConnectionAvailable: function() {
            return !0
          },
          isCompatible: function() {
            return !0
          },
          autoSelect: function() {},
          setPlatformAPI: function() {},
          isCrossPublisherIdChanged: function() {
            return !1
          },
          setTimeout: function(a, b) {
            return setTimeout(a, b)
          },
          clearTimeout: function(a) {
            return clearTimeout(a)
          },
          getDeviceArchitecture: function() {
            return h.UNKNOWN_VALUE
          },
          getConnectionType: function() {
            return h.UNKNOWN_VALUE
          },
          getDeviceJailBrokenFlag: function() {
            return h.UNKNOWN_VALUE
          },
          isConnSecure: function() {
            return "s" === document.location.href.charAt(4)
          },
          processMeasurementLabels: function() {}
        }
      }(),
      h = {
        UNKNOWN_VALUE: "unknown",
        UNKNOWN_RESOLUTION: "0x0"
      };
    b.jsonObjectToStringDictionary = function(a) {
      var b = {};
      for (var c in a) {
        var d = a[c];
        null === d || void 0 === d ? b[c] = d : b[c] = a[c] + ""
      }
      return b
    }, b.getKeys = function(a, b) {
      var c, d = [];
      for (c in a) b && !b.test(c) || !a.hasOwnProperty(c) || (d[d.length] = c);
      return d
    }, b.fixEventTime = function(a) {
      if (a.ns_ts) return parseInt(a.ns_ts);
      var b = +new Date;
      return a.ns_ts = String(b), b
    }, b.isBrowser = function() {
      return "undefined" != typeof window && "undefined" != typeof document
    }, b.addNewPlaybackInterval = function(a, c, d, e) {
      var f = {};
      if (!(d >= c)) return b.cloneObject(a);
      if (f.start = c, f.end = d, 0 == a.length) return a.push(f), b.cloneObject(a);
      var g;
      for (g = 0; g < a.length; g++)
        if (f.start >= a[g].start && f.end <= a[g].end) return b.cloneObject(a);
      var h, i = !1;
      for (h = 0; h < a.length; h++)
        if (h + 1 === a.length && f.start >= a[h].start || f.start >= a[h].start && f.start < a[h + 1].start) {
          a.splice(h + 1, 0, f), i = !0;
          break
        }
      i || a.splice(0, 0, f);
      var j = [a[0]];
      for (g = 1; g < a.length; g++) j[j.length - 1].end + e < a[g].start ? j.push(a[g]) : j[j.length - 1].end < a[g].end && (j[j.length - 1].end = a[g].end);
      return b.cloneObject(j)
    };
    var i = function() {
        var a = ["play", "pause", "pause-on-buffering", "end", "buffer", "buffer-stop", "keep-alive", "hb", "custom", "load", "start", "skstart", "adskip", "cta", "error", "trans", "drmfa", "drmap", "drmde", "bitrt", "playrt", "volume", "window", "audio", "video", "subs", "cdn"];
        return {
          PLAY: 0,
          PAUSE: 1,
          PAUSE_ON_BUFFERING: 2,
          END: 3,
          BUFFER: 4,
          BUFFER_STOP: 5,
          KEEPALIVE: 6,
          HEARTBEAT: 7,
          CUSTOM: 8,
          LOAD: 9,
          START: 10,
          SEEK_START: 11,
          AD_SKIP: 12,
          CTA: 13,
          ERROR: 14,
          TRANSFER: 15,
          DRM_FAILED: 16,
          DRM_APPROVED: 17,
          DRM_DENIED: 18,
          BIT_RATE: 19,
          PLAYBACK_RATE: 20,
          VOLUME: 21,
          WINDOW_STATE: 22,
          AUDIO: 23,
          VIDEO: 24,
          SUBS: 25,
          CDN: 26,
          toString: function(b) {
            return a[b]
          }
        }
      }(),
      j = function() {
        return {
          IDLE: 0,
          PLAYBACK_NOT_STARTED: 1,
          PLAYING: 2,
          PAUSED: 3,
          BUFFERING_BEFORE_PLAYBACK: 4,
          BUFFERING_DURING_PLAYBACK: 5,
          BUFFERING_DURING_SEEKING: 6,
          BUFFERING_DURING_PAUSE: 7,
          SEEKING_BEFORE_PLAYBACK: 8,
          SEEKING_DURING_PLAYBACK: 9,
          SEEKING_DURING_BUFFERING: 10,
          SEEKING_DURING_PAUSE: 11,
          PAUSED_DURING_BUFFERING: 12
        }
      }(),
      k = function() {
        var a = ["c", "s", "r"];
        return {
          SINGLE_CLIP: 0,
          SEGMENTED: 1,
          REDUCED: 2,
          toString: function(b) {
            return a[b]
          }
        }
      }(),
      l = {
        STREAMSENSE_VERSION: "5.1.1.160316",
        MODEL_VERSION: "5.1",
        DEFAULT_PLAYERNAME: "js_api",
        DEFAULT_HEARTBEAT_INTERVAL: [{
          playingtime: 6e4,
          interval: 1e4
        }, {
          playingtime: null,
          interval: 6e4
        }],
        DEFAULT_KEEP_ALIVE_INTERVAL: 12e5,
        DEFAULT_PAUSED_ON_BUFFERING_INTERVAL: 500,
        C1_VALUE: "19",
        C10_VALUE: "js",
        NS_AP_C12M_VALUE: "1",
        NS_NC_VALUE: "1",
        PAGE_NAME_LABEL: "name",
        RESTRICTED_URL_LENGTH_LIMIT: 2048,
        URL_LENGTH_LIMIT: 4096,
        THROTTLING_DELAY: 500,
        INTERVAL_MERGE_TOLERANCE: 500,
        STANDARD_METADATA_LABELS: ["ns_st_ci", "ns_st_pr", "ns_st_sn", "ns_st_en", "ns_st_ep", "ns_st_ty", "ns_st_ct", "ns_st_li", "ns_st_ad", "ns_st_bn", "ns_st_tb", "ns_st_an", "ns_st_ta", "ns_st_pu", "c3", "c4", "c6"],
        LABELS_ORDER: ["c1", "c2", "ca2", "cb2", "cc2", "cd2", "ns_site", "ca_ns_site", "cb_ns_site", "cc_ns_site", "cd_ns_site", "ns_vsite", "ca_ns_vsite", "cb_ns_vsite", "cc_ns_vsite", "cd_ns_vsite", "ns_alias", "ca_ns_alias", "cb_ns_alias", "cc_ns_alias", "cd_ns_alias", "ns_ap_an", "ca_ns_ap_an", "cb_ns_ap_an", "cc_ns_ap_an", "cd_ns_ap_an", "ns_ap_pn", "ns_ap_pv", "c12", "ca12", "cb12", "cc12", "cd12", "ns_ak", "ns_ap_hw", "name", "ns_ap_ni", "ns_ap_ec", "ns_ap_ev", "ns_ap_device", "ns_ap_id", "ns_ap_csf", "ns_ap_bi", "ns_ap_pfm", "ns_ap_pfv", "ns_ap_ver", "ca_ns_ap_ver", "cb_ns_ap_ver", "cc_ns_ap_ver", "cd_ns_ap_ver", "ns_ap_sv", "ns_ap_cv", "ns_type", "ca_ns_type", "cb_ns_type", "cc_ns_type", "cd_ns_type", "ns_radio", "ns_nc", "cs_partner", "cs_xcid", "ns_ap_ui", "ca_ns_ap_ui", "cb_ns_ap_ui", "cc_ns_ap_ui", "cd_ns_ap_ui", "ns_ap_gs", "ns_st_sv", "ns_st_pv", "ns_st_smv", "ns_st_it", "ns_st_id", "ns_st_ec", "ns_st_sp", "ns_st_sc", "ns_st_sq", "ns_st_ppc", "ns_st_apc", "ns_st_spc", "ns_st_cn", "ns_st_ev", "ns_st_po", "ns_st_cl", "ns_st_el", "ns_st_sl", "ns_st_pb", "ns_st_hc", "ns_st_mp", "ca_ns_st_mp", "cb_ns_st_mp", "cc_ns_st_mp", "cd_ns_st_mp", "ns_st_mv", "ca_ns_st_mv", "cb_ns_st_mv", "cc_ns_st_mv", "cd_ns_st_mv", "ns_st_pn", "ns_st_tp", "ns_st_ad", "ns_st_li", "ns_st_ci", "ns_st_si", "ns_st_pt", "ns_st_dpt", "ns_st_ipt", "ns_st_et", "ns_st_det", "ns_st_upc", "ns_st_dupc", "ns_st_iupc", "ns_st_upa", "ns_st_dupa", "ns_st_iupa", "ns_st_lpc", "ns_st_dlpc", "ns_st_lpa", "ns_st_dlpa", "ns_st_pa", "ns_ap_jb", "ns_ap_et", "ns_ap_res", "ns_ap_sd", "ns_ap_po", "ns_ap_ot", "ns_ap_c12m", "cs_c12u", "ca_cs_c12u", "cb_cs_c12u", "cc_cs_c12u", "cd_cs_c12u", "ns_ap_install", "ns_ap_updated", "ns_ap_lastrun", "ns_ap_cs", "ns_ap_runs", "ns_ap_usage", "ns_ap_fg", "ns_ap_ft", "ns_ap_dft", "ns_ap_bt", "ns_ap_dbt", "ns_ap_dit", "ns_ap_as", "ns_ap_das", "ns_ap_it", "ns_ap_uc", "ns_ap_aus", "ns_ap_daus", "ns_ap_us", "ns_ap_dus", "ns_ap_ut", "ns_ap_oc", "ns_ap_uxc", "ns_ap_uxs", "ns_ap_lang", "ns_ap_ar", "ns_ap_miss", "ns_ts", "ns_st_ca", "ns_st_cp", "ns_st_er", "ca_ns_st_er", "cb_ns_st_er", "cc_ns_st_er", "cd_ns_st_er", "ns_st_pe", "ns_st_ui", "ca_ns_st_ui", "cb_ns_st_ui", "cc_ns_st_ui", "cd_ns_st_ui", "ns_st_bc", "ns_st_dbc", "ns_st_bt", "ns_st_dbt", "ns_st_bp", "ns_st_lt", "ns_st_skc", "ns_st_dskc", "ns_st_ska", "ns_st_dska", "ns_st_skd", "ns_st_skt", "ns_st_dskt", "ns_st_pc", "ns_st_dpc", "ns_st_pp", "ns_st_br", "ns_st_pbr", "ns_st_rt", "ns_st_prt", "ns_st_ub", "ns_st_vo", "ns_st_pvo", "ns_st_ws", "ns_st_pws", "ns_st_ki", "ns_st_rp", "ns_st_bn", "ns_st_tb", "ns_st_an", "ns_st_ta", "ns_st_pl", "ns_st_pr", "ns_st_sn", "ns_st_en", "ns_st_ep", "ns_st_sr", "ns_st_ty", "ns_st_ct", "ns_st_cs", "ns_st_ge", "ns_st_st", "ns_st_ce", "ns_st_ia", "ns_st_dt", "ns_st_ddt", "ns_st_tdt", "ns_st_tm", "ns_st_dtm", "ns_st_ttm", "ns_st_de", "ns_st_pu", "ns_st_ti", "ns_st_cu", "ns_st_fee", "ns_st_at", "ns_st_pat", "ns_st_vt", "ns_st_pvt", "ns_st_tt", "ns_st_ptt", "ns_st_cdn", "ns_st_pcdn", "ns_ap_i1", "ns_ap_i2", "ns_ap_i3", "ns_ap_i4", "ns_ap_i5", "ns_ap_i6", "ns_ap_referrer", "ns_clid", "ns_campaign", "ns_source", "ns_mchannel", "ns_linkname", "ns_fee", "gclid", "utm_campaign", "utm_source", "utm_medium", "utm_term", "utm_content", "ns_ecommerce", "ns_ec_sv", "ns_client_id", "ns_order_id", "ns_ec_cur", "ns_orderline_id", "ns_orderlines", "ns_prod_id", "ns_qty", "ns_prod_price", "ns_prod_grp", "ns_brand", "ns_shop", "ns_category", "category", "ns_c", "ns_search_term", "ns_search_result", "ns_m_exp", "ns_m_chs", "c3", "ca3", "cb3", "cc3", "cd3", "c4", "ca4", "cb4", "cc4", "cd4", "c5", "ca5", "cb5", "cc5", "cd5", "c6", "ca6", "cb6", "cc6", "cd6", "c10", "c11", "c13", "c14", "c15", "c16", "c7", "c8", "c9", "ns_ap_er"]
      },
      m = function() {
        function a() {
          function a() {
            I = {}, I.ns_st_pt = "0", I.ns_st_bt = "0", I.ns_st_bc = "0", I.ns_st_pc = "0", I.ns_st_sq = "0", I.ns_st_cl = "0", I.ns_st_pn = "1", I.ns_st_tp = "1", I.ns_st_skc = "0", I.ns_st_et = "0", I.ns_st_cn = "1", I.ns_st_sc = "0", I.ns_st_ska = "0", I.ns_st_skd = "0", I.ns_st_skt = "0", I.ns_st_upc = "0", I.ns_st_lpc = "0", I.ns_st_upa = "0", I.ns_st_lpa = "0", I.ns_st_ub = "0", I.ns_st_br = "0", f = !1, e = !1, d = h.UNKNOWN_VALUE, g = NaN, m = 0, j = 0, i = NaN, n = NaN, p = 0, o = 0, k = 0, s = NaN, q = [], r = [], t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = NaN, A = 0, B = !1, C = NaN, F = !1, E = 0, H = 0, D = 0, G = 0, J = 0, K = 0, L = 0, M = 0, N = 0
          }

          function c() {
            var a, b, c = 0;
            for (a = 0; a < q.length; a++) c += Math.abs(q[a].end - q[a].start);
            O.setUniquePlaybackInterval(c);
            var d = 0;
            for (a = 0; a < q.length; a++) b = Math.abs(q[a].end - q[a].start), b > d && (d = b);
            O.setLongestPlaybackInterval(d);
            var e = 0;
            for (a = 0; a < r.length; a++) e += Math.abs(r[a].end - r[a].start);
            O.setAssetUniquePlaybackInterval(e);
            var f = 0;
            for (a = 0; a < r.length; a++) b = Math.abs(r[a].end - r[a].start), b > f && (f = b);
            O.setAssetLongestPlaybackInterval(f)
          }
          var d, e, f, g, i, j, k, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O = this,
            P = l.INTERVAL_MERGE_TOLERANCE;
          b.extend(this, {
            getHash: function() {
              return d
            },
            setHash: function(a) {
              d = a
            },
            setPlaybackIntervalMergeTolerance: function(a) {
              P = a
            },
            getPlaybackIntervalMergeTolerance: function() {
              return P
            },
            setLabels: function(a) {
              null != a && b.extend(I, a)
            },
            getLabels: function() {
              return I
            },
            setLabel: function(a, b) {
              var c = {};
              c[a] = b, O.setLabels(c)
            },
            getLabel: function(a) {
              return I[a]
            },
            getClipNumber: function() {
              return parseInt(O.getLabel("ns_st_cn"))
            },
            setClipNumber: function(a) {
              O.setLabel("ns_st_cn", String(a))
            },
            getPartNumber: function() {
              return parseInt(O.getLabel("ns_st_pn"))
            },
            createLabels: function(a) {
              var c = a || {};
              c.ns_st_dbt = String(O.getBufferingTime() - A), A = O.getBufferingTime(), c.ns_st_det = String(O.getElapsedTime() - o), o = O.getElapsedTime(), c.ns_st_dupc = String(O.getUniquePlaybackInterval() - t), t = O.getUniquePlaybackInterval(), parseInt(c.ns_st_dupc) < 0 && (c.ns_st_dupc = "0");
              var d;
              d = b.exists(c.ns_st_upc) ? parseInt(c.ns_st_upc) : O.getUniquePlaybackInterval(), c.ns_st_iupc = String(d - u), u = d, parseInt(c.ns_st_iupc) < 0 && (c.ns_st_iupc = "0"), c.ns_st_dupa = String(O.getAssetUniquePlaybackInterval() - v), v = O.getAssetUniquePlaybackInterval(), parseInt(c.ns_st_dupa) < 0 && (c.ns_st_dupa = "0");
              var e;
              e = b.exists(c.ns_st_upa) ? parseInt(c.ns_st_upa) : O.getAssetUniquePlaybackInterval(), c.ns_st_iupa = String(e - w), w = e, parseInt(c.ns_st_iupa) < 0 && (c.ns_st_iupa = "0"), c.ns_st_dlpc = String(O.getLongestPlaybackInterval() - x), x = O.getLongestPlaybackInterval(), parseInt(c.ns_st_dlpc) < 0 && (c.ns_st_dlpc = "0"), c.ns_st_dlpa = String(O.getAssetLongestPlaybackInterval() - y), y = O.getAssetLongestPlaybackInterval(), parseInt(c.ns_st_dlpa) < 0 && (c.ns_st_dlpa = "0");
              var g;
              return g = b.exists(c.ns_st_pt) ? parseInt(c.ns_st_pt) : O.getPlaybackTime(), c.ns_st_ipt = String(g - k), k = g, c.ns_st_dpt = String(O.getPlaybackTime() - j), j = O.getPlaybackTime(), c.ns_st_dpc = String(O.getPauses() - J), J = O.getPauses(), c.ns_st_dskc = String(O.getSeeks() - K), K = O.getSeeks(), c.ns_st_dbc = String(O.getBuffers() - L), L = O.getBuffers(), c.ns_st_dskt = String(O.getSeekingTime() - D), D = O.getSeekingTime(), c.ns_st_dska = String(O.getSeekingAmount() - G), G = O.getSeekingAmount(), b.extend(c, O.getLabels()), O.setSeekingDirection(0), f && (c.ns_st_spc = String(M), c.ns_st_apc = String(N)), f || b.parseBoolean(c.ns_st_sc) || (c.ns_st_sc = "1"), c
            },
            getVideoTrack: function() {
              return O.getLabel("ns_st_vt")
            },
            setVideoTrack: function(a) {
              O.setLabel("ns_st_vt", String(a))
            },
            getAudioTrack: function() {
              return O.getLabel("ns_st_at")
            },
            setAudioTrack: function(a) {
              O.setLabel("ns_st_at", String(a))
            },
            getSubtitleTrack: function() {
              return O.getLabel("ns_st_tt")
            },
            setSubtitleTrack: function(a) {
              O.setLabel("ns_st_tt", String(a))
            },
            getCDN: function() {
              return O.getLabel("ns_st_cdn")
            },
            setCDN: function(a) {
              O.setLabel("ns_st_cdn", String(a))
            },
            getClipPlaybackIntervals: function() {
              return q
            },
            setClipPlaybackIntervals: function(a) {
              q = a
            },
            getAssetPlaybackIntervals: function() {
              return r
            },
            getUniquePlaybackInterval: function() {
              return parseInt(O.getLabel("ns_st_upc"))
            },
            getAssetUniquePlaybackInterval: function() {
              return parseInt(O.getLabel("ns_st_upa"))
            },
            setAssetUniquePlaybackInterval: function(a) {
              O.setLabel("ns_st_upa", String(a))
            },
            setUniquePlaybackInterval: function(a) {
              O.setLabel("ns_st_upc", String(a))
            },
            getLongestPlaybackInterval: function() {
              return parseInt(O.getLabel("ns_st_lpc"))
            },
            setLongestPlaybackInterval: function(a) {
              O.setLabel("ns_st_lpc", String(a))
            },
            getAssetLongestPlaybackInterval: function() {
              return parseInt(O.getLabel("ns_st_lpa"))
            },
            setAssetLongestPlaybackInterval: function(a) {
              O.setLabel("ns_st_lpa", String(a))
            },
            incrementPauses: function() {
              O.setLabel("ns_st_pc", String(O.getPauses() + 1))
            },
            incrementSeeks: function() {
              O.setLabel("ns_st_skc", String(O.getSeeks() + 1))
            },
            incrementPlayCounter: function() {
              O.setLabel("ns_st_sq", String(O.getPlayCounter() + 1))
            },
            getPlayCounter: function() {
              return parseInt(O.getLabel("ns_st_sq"))
            },
            getBufferingTime: function() {
              return parseInt(O.getLabel("ns_st_bt"))
            },
            setBufferingTime: function(a) {
              O.setLabel("ns_st_bt", String(a))
            },
            addBufferingTime: function(a) {
              if (!isNaN(z)) {
                var b = O.getBufferingTime();
                b += a - z, O.setBufferingTime(b), z = NaN
              }
            },
            setPlaybackStartPosition: function(a) {
              s = parseInt(a)
            },
            getPlaybackStartPosition: function() {
              return s
            },
            addInterval: function(a) {
              isNaN(s) || isNaN(a) || (q = b.addNewPlaybackInterval(q, s, a, P), r = b.addNewPlaybackInterval(r, s, a, P), c(), s = NaN)
            },
            getElapsedTime: function() {
              return parseInt(O.getLabel("ns_st_et"))
            },
            setElapsedTime: function(a) {
              O.setLabel("ns_st_et", String(a))
            },
            addElapsedTime: function(a) {
              if (!isNaN(n)) {
                var b = O.getElapsedTime();
                b += a - n, O.setElapsedTime(b), n = NaN
              }
            },
            getElapsedTimestamp: function() {
              return n
            },
            setElapsedTimestamp: function(a) {
              n = a
            },
            addPlaybackTime: function(a) {
              if (!isNaN(g)) {
                var b = O.getPlaybackTime();
                b += a - g, O.setPlaybackTime(b), g = NaN
              }
            },
            getPlaybackTime: function() {
              return parseInt(O.getLabel("ns_st_pt"))
            },
            getExpectedPlaybackPosition: function(a) {
              return isNaN(g) || (m += a - g), m
            },
            setPlaybackTimeOffset: function(a) {
              m = a
            },
            getPlaybackTimeOffset: function() {
              return m
            },
            setPlaybackTime: function(a) {
              O.setLabel("ns_st_pt", String(a))
            },
            getPlaybackTimestamp: function() {
              return g
            },
            setPlaybackTimestamp: function(a) {
              g = a
            },
            setPreviousPlaybackTime: function(a) {
              j = a
            },
            setPreviousPlaybackTimestamp: function(a) {
              i = a
            },
            getBufferingTimestamp: function() {
              return z
            },
            setBufferingTimestamp: function(a) {
              z = a
            },
            getPauses: function() {
              return parseInt(O.getLabel("ns_st_pc"))
            },
            setPauses: function(a) {
              O.setLabel("ns_st_pc", String(a))
            },
            getSeeks: function() {
              return parseInt(O.getLabel("ns_st_skc"))
            },
            setSeeks: function(a) {
              O.setLabel("ns_st_skc", String(a))
            },
            setSeeking: function(a) {
              B = a
            },
            isSeeking: function() {
              return B
            },
            setCollectingSeekingTime: function(a) {
              F = a
            },
            isCollectingSeekingTime: function() {
              return F
            },
            setClipStarted: function(a) {
              e = a
            },
            isClipStarted: function() {
              return e
            },
            setPlaybackStarted: function(a) {
              f = a
            },
            isPlaybackStarted: function() {
              return f
            },
            setSeekingTimestamp: function(a) {
              C = a
            },
            getSeekingTimestamp: function() {
              return C
            },
            addSeekingTime: function(a) {
              if (!isNaN(C)) {
                var b = O.getSeekingTime();
                b += a - C, O.setSeekingTime(b), C = NaN
              }
            },
            getSeekingTime: function() {
              return parseInt(O.getLabel("ns_st_skt"))
            },
            setSeekingTime: function(a) {
              O.setLabel("ns_st_skt", String(a))
            },
            setSeekingTimeBeforeEnd: function(a) {
              H = a
            },
            getSeekingTimeBeforeEnd: function() {
              return H
            },
            setSeekStartPosition: function(a) {
              E = a
            },
            getSeekStartPosition: function() {
              return E
            },
            setSeekingAmount: function(a) {
              O.setLabel("ns_st_ska", String(a))
            },
            getSeekingAmount: function() {
              return parseInt(O.getLabel("ns_st_ska"))
            },
            addSeekingAmount: function(a) {
              var b = O.getSeekingAmount();
              b += Math.abs(a - E), O.setSeekingAmount(b);
              var c;
              E == a ? c = 0 : E > a ? c = -1 : a > E && (c = 1), O.setSeekingDirection(c), E = 0
            },
            getSeekingDirection: function() {
              return parseInt(O.getLabel("ns_st_skd"))
            },
            setSeekingDirection: function(a) {
              O.setLabel("ns_st_skd", String(a))
            },
            resetClipLifecycleLabels: function() {
              I.ns_st_pt = "0", j = 0, k = 0, I.ns_st_bt = "0", A = 0, I.ns_st_bc = "0", L = 0, I.ns_st_pc = "0", J = 0, I.ns_st_sq = "0", I.ns_st_upa = "0", v = 0, w = 0, I.ns_st_et = "0", o = 0, I.ns_st_lpa = "0", y = 0, I.ns_st_skt = "0", D = 0, I.ns_st_ska = "0", G = 0, I.ns_st_skc = "0", K = 0
            },
            incrementSegmentPlaybackCounter: function() {
              M++
            },
            incrementClipLoadCounter: function() {
              O.setLabel("ns_st_sc", String(O.getClipLoadCounter() + 1))
            },
            incrementAssetPlaybackCounter: function() {
              N++
            },
            setPreviousUniquePlaybackInterval: function(a) {
              t = a
            },
            setPreviousEventIndependentUniquePlaybackInterval: function(a) {
              u = a
            },
            setPreviousLongestPlaybackInterval: function(a) {
              x = a
            },
            resetAssetPlaybackCounters: function() {
              r = [], O.setAssetUniquePlaybackInterval(0), v = 0, w = 0, O.setAssetLongestPlaybackInterval(0), y = 0
            },
            setSegmentPlaybackCounter: function(a) {
              M = a
            },
            setClipLoadCounter: function(a) {
              O.setLabel("ns_st_sc", String(a))
            },
            setAssetPlaybackCounter: function(a) {
              N = a
            },
            setLowestPartNumberPlayed: function(a) {
              p = a
            },
            getSegmentPlaybackCounter: function() {
              return M
            },
            getClipLoadCounter: function() {
              return parseInt(O.getLabel("ns_st_sc"))
            },
            getAssetPlaybackCounter: function() {
              return N
            },
            getLowestPartNumberPlayed: function() {
              return p
            },
            getBuffers: function() {
              return parseInt(O.getLabel("ns_st_bc"))
            },
            incrementBufferCount: function() {
              O.setLabel("ns_st_bc", String(O.getBuffers() + 1))
            },
            getPreviousBufferingTime: function() {
              return A
            }
          }), a()
        }
        return a.resetClip = function(a, b, c) {
          for (var d = a.getLabels(), e = {}, f = 0; c && f < c.length; ++f) d.hasOwnProperty(c[f]) && (e[c[f]] = d[c[f]]);
          b.setLabels(e), b.setPlaybackIntervalMergeTolerance(a.getPlaybackIntervalMergeTolerance())
        }, a
      }(),
      n = function() {
        function a() {
          function a() {
            c = new m, f = {}, f.ns_st_bp = "0", f.ns_st_pa = "0", f.ns_st_pp = "0", f.ns_st_sp = "1", f.ns_st_id = String(+new Date), d = NaN, e = NaN, h = {}, i = 0, g = !1, j = !1, k = 0
          }
          var c, d, e, f, g, h, i, j, k, l = this;
          b.extend(this, {
            resetClip: function() {
              var a = c;
              c = new m, m.resetClip(a, c)
            },
            hashExists: function(a) {
              return null != h[a]
            },
            storeHash: function(a) {
              h[a] = {}
            },
            removeHash: function(a) {
              delete h[a]
            },
            storeClipPlaybackCounters: function() {
              for (var a in h)
                if (h.hasOwnProperty(a) && h[a].clipNumber === c.getClipNumber()) {
                  b.extend(h[a], {
                    segmentPlaybackCounter: c.getSegmentPlaybackCounter(),
                    clipLoadCounter: c.getClipLoadCounter(),
                    assetPlaybackCounter: c.getAssetPlaybackCounter(),
                    lowestPartNumberPlayed: c.getLowestPartNumberPlayed(),
                    seeking: c.isSeeking(),
                    seekingTimeBeforeEnd: c.getSeekingTimeBeforeEnd(),
                    seekingStartPosition: c.getSeekStartPosition(),
                    clipPlaybackIntervals: c.getClipPlaybackIntervals(),
                    uniquePlaybackInterval: c.getUniquePlaybackInterval(),
                    longestPlaybackInterval: c.getLongestPlaybackInterval(),
                    videoTrack: c.getVideoTrack(),
                    audioTrack: c.getAudioTrack(),
                    subtitleTrack: c.getSubtitleTrack(),
                    cdn: c.getCDN()
                  });
                  break
                }
            },
            getStoredClipRegisters: function(a) {
              return h[a]
            },
            getClipNumber: function(a) {
              return h[a].clipNumber
            },
            getMaxClipNumber: function() {
              return i
            },
            storeClipNumber: function(a, b) {
              h[a].clipNumber = b, b > i && (i = b)
            },
            setLabels: function(a) {
              null != a && b.extend(f, a)
            },
            getLabels: function() {
              return f
            },
            setLabel: function(a, b) {
              var c = {};
              c[a] = b, l.setLabels(c)
            },
            getLabel: function(a) {
              return f[a]
            },
            getClip: function() {
              return c
            },
            createLabels: function(a) {
              var d = a || {};
              return j || (d.ns_st_pb = null != d.ns_st_pb ? d.ns_st_pb : "1"), b.extend(d, l.getLabels()), c.isPlaybackStarted() && (d.ns_st_ppc = String(k)), d
            },
            incrementPlayCounter: function() {
              l.setLabel("ns_st_sp", String(parseInt(l.getLabel("ns_st_sp")) + 1))
            },
            incrementPauses: function() {
              l.setLabel("ns_st_pp", String(l.getPauses() + 1))
            },
            addPlaybackTime: function(a) {
              if (!isNaN(e)) {
                var b = l.getPlaybackTime();
                b += a - e, l.setPlaybackTime(b), e = NaN
              }
            },
            addBufferingTime: function(a) {
              if (!isNaN(d)) {
                var b = l.getBufferingTime();
                b += a - d, l.setBufferingTime(b), d = NaN
              }
            },
            getBufferingTime: function() {
              return parseInt(l.getLabel("ns_st_bp"))
            },
            setBufferingTime: function(a) {
              l.setLabel("ns_st_bp", String(a))
            },
            getPlaybackTime: function() {
              return parseInt(l.getLabel("ns_st_pa"))
            },
            setBufferingTimestamp: function(a) {
              d = a
            },
            getBufferingTimestamp: function() {
              return d
            },
            setPlaybackTime: function(a) {
              l.setLabel("ns_st_pa", String(a))
            },
            setPlaybackTimestamp: function(a) {
              e = a
            },
            getPlaybackTimestamp: function() {
              return e
            },
            getPauses: function() {
              return parseInt(l.getLabel("ns_st_pp"))
            },
            setPauses: function(a) {
              l.setLabel("ns_st_pp", String(a))
            },
            isPlaylistStarted: function() {
              return g
            },
            setPlaylistStarted: function(a) {
              g = a
            },
            getPlaybackCounter: function() {
              return k
            },
            incrementPlaybackCounter: function() {
              k++
            },
            setFirstEventSent: function(a) {
              j = a
            }
          }), a()
        }
        return a.resetPlaylist = function(b, c, d) {
          for (var e = b.getClip(), f = b.getLabels(), g = {}, h = 0; d && h < d.length; h++) f.hasOwnProperty(d[h]) && (g[d[h]] = f[d[h]]);
          c = new a, c.setLabels(g), m.resetClip(e, c.getClip(), d)
        }, a
      }(),
      o = function() {
        return function(a) {
          function c() {
            e = 1
          }

          function d(c) {
            f = b.extend({}, c);
            var d = a.getSSECore().getPixelURL();
            if (a.getAppCore()) {
              if (a.getSSECore().isProperlyInitialized()) {
                var e = a.getSSECore().getExports().am,
                  g = a.getSSECore().getExports().et,
                  h = e.newApplicationMeasurement(a.getAppCore(), g.HIDDEN, c, d);
                a.getAppCore().getQueue().offer(h)
              }
            } else d && a.getSSECore().getPlatformAPI().httpGet(a.getSSECore().prepareUrl(d, c))
          }
          var e, f, g = this;
          b.extend(this, {
            newEvent: function(a) {
              d(a.eventLabels), a.eventType != i.HEARTBEAT && g.incrementEventCounter()
            },
            getEventCounter: function() {
              return e
            },
            incrementEventCounter: function() {
              e++
            },
            setEventCounter: function(a) {
              e = a
            },
            getMeasurementSnapshot: function() {
              return f
            }
          }), c()
        }
      }(),
      p = function() {
        return function(a) {
          function c() {
            g = 0, h = 0
          }

          function d() {
            h++;
            var c = {},
              d = b.fixEventTime(c);
            c.ns_st_po = String(a.getPlaylist().getClip().getPlaybackTimeOffset() + (d - a.getPlaylist().getClip().getPlaybackTimestamp())), c.ns_st_pa = String(a.getPlaylist().getPlaybackTime() + (d - a.getPlaylist().getPlaybackTimestamp())), c.ns_st_pt = String(a.getPlaylist().getClip().getPlaybackTime() + (d - a.getPlaylist().getClip().getPlaybackTimestamp())), c.ns_st_dpt = String(d - a.getPlaylist().getClip().getPlaybackTimestamp()), a.getStateMachine().getCurrentState() == j.BUFFERING_DURING_PLAYBACK ? (c.ns_st_bp = String(a.getPlaylist().getBufferingTime() + (d - a.getPlaylist().getBufferingTimestamp())), c.ns_st_bt = String(a.getPlaylist().getClip().getBufferingTime() + (d - a.getPlaylist().getClip().getBufferingTimestamp())), c.ns_st_dbt = String(d - a.getPlaylist().getClip().getBufferingTimestamp())) : c.ns_st_dbt = String(a.getPlaylist().getClip().getBufferingTime() - a.getPlaylist().getClip().getPreviousBufferingTime()), c.ns_st_et = String(a.getPlaylist().getClip().getElapsedTime() + (d - a.getPlaylist().getClip().getElapsedTimestamp())), c.ns_st_det = String(d - a.getPlaylist().getClip().getElapsedTimestamp());
            var e = b.cloneObject(a.getPlaylist().getClip().getClipPlaybackIntervals()),
              f = b.cloneObject(a.getPlaylist().getClip().getAssetPlaybackIntervals());
            e = b.addNewPlaybackInterval(e, a.getPlaylist().getClip().getPlaybackStartPosition(), parseInt(c.ns_st_po), a.getPlaylist().getClip().getPlaybackIntervalMergeTolerance()), f = b.addNewPlaybackInterval(f, a.getPlaylist().getClip().getPlaybackStartPosition(), parseInt(c.ns_st_po), a.getPlaylist().getClip().getPlaybackIntervalMergeTolerance());
            var l, m, n = 0;
            for (l = 0; l < e.length; l++) n += Math.abs(e[l].end - e[l].start);
            c.ns_st_upc = String(n), c.ns_st_dupc = String(n - a.getPlaylist().getClip().getUniquePlaybackInterval());
            var o = 0;
            for (l = 0; l < e.length; l++) m = Math.abs(e[l].end - e[l].start), m > o && (o = m);
            c.ns_st_lpc = String(o), c.ns_st_dlpc = String(o - a.getPlaylist().getClip().getLongestPlaybackInterval());
            var p = 0;
            for (l = 0; l < f.length; l++) p += Math.abs(f[l].end - f[l].start);
            c.ns_st_upa = String(p), c.ns_st_dupa = String(p - a.getPlaylist().getClip().getAssetUniquePlaybackInterval());
            var q = 0;
            for (l = 0; l < f.length; l++) m = Math.abs(f[l].end - f[l].start), m > q && (q = m);
            c.ns_st_lpa = String(q), c.ns_st_dlpa = String(q - a.getPlaylist().getClip().getAssetLongestPlaybackInterval()), c.ns_st_hc = String(a.getHeartbeat().getCount());
            var r = a.getSSECore().createLabels(i.HEARTBEAT, c, d);
            a.getEventManager().newEvent(r), g = 0, k.resume()
          }

          function e() {
            null != f && (a.getSSECore().getPlatformAPI().clearTimeout(f), f = null)
          }
          var f, g, h, k = this,
            m = l.DEFAULT_HEARTBEAT_INTERVAL;
          b.extend(this, {
            getCount: function() {
              return h
            },
            setIntervals: function(a) {
              m = a
            },
            getInterval: function(a) {
              var b = 0;
              if (null != m)
                for (var c = 0; c < m.length; c++) {
                  var d = m[c],
                    e = d.playingtime;
                  if (!e || e > a) {
                    b = d.interval;
                    break
                  }
                }
              return b
            },
            resume: function() {
              e();
              var b = k.getInterval(a.getPlaylist().getClip().getPlaybackTime() + (+new Date - a.getPlaylist().getClip().getPlaybackTimestamp()));
              if (b > 0) {
                var c = g > 0 ? g : b;
                f = a.getSSECore().getPlatformAPI().setTimeout(d, c)
              }
              g = 0
            },
            pause: function() {
              e();
              var b = k.getInterval(a.getPlaylist().getClip().getPlaybackTime() + (+new Date - a.getPlaylist().getClip().getPlaybackTimestamp()));
              g = b - (a.getPlaylist().getClip().getPlaybackTime() + (+new Date - a.getPlaylist().getClip().getPlaybackTimestamp())) % b
            }
          }), c()
        }
      }(),
      q = function() {
        return function(a) {
          function c() {}

          function d() {
            var c = {},
              d = b.fixEventTime(c);
            c.ns_st_po = String(a.getPlaylist().getClip().getExpectedPlaybackPosition(d)), a.getPlaylist().addPlaybackTime(d), a.getPlaylist().setPlaybackTimestamp(d), a.getPlaylist().getClip().addPlaybackTime(d), a.getPlaylist().getClip().setPlaybackTimestamp(d), a.getStateMachine().getCurrentState() == j.BUFFERING_DURING_PLAYBACK && (a.getPlaylist().addBufferingTime(d), a.getPlaylist().setBufferingTimestamp(d), a.getPlaylist().getClip().addBufferingTime(d), a.getPlaylist().getClip().setBufferingTimestamp(d)), a.getPlaylist().getClip().addElapsedTime(d), a.getPlaylist().getClip().setElapsedTimestamp(d), a.getPlaylist().getClip().addInterval(parseInt(c.ns_st_po)), a.getPlaylist().getClip().setPlaybackStartPosition(parseInt(c.ns_st_po));
            var e = a.getSSECore().createLabels(i.KEEPALIVE, c, d);
            a.getEventManager().newEvent(e), g.resume()
          }

          function e() {
            null != f && (a.getSSECore().getPlatformAPI().clearTimeout(f), f = null)
          }
          var f, g = this,
            h = l.DEFAULT_KEEP_ALIVE_INTERVAL;
          b.extend(g, {
            resume: function() {
              e(), f = a.getSSECore().getPlatformAPI().setTimeout(d, h)
            },
            pause: function() {
              e()
            },
            setInterval: function(a) {
              h = a
            },
            getInterval: function() {
              return h
            }
          }), c()
        }
      }(),
      r = function() {
        return function(a) {
          function c() {
            f = j.IDLE, e = null, d = NaN
          }
          var d, e, f, g = this;
          b.extend(g, {
            eventTypeToState: function(a) {
              if (f == j.IDLE) {
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.SEEK_START) return j.SEEKING_BEFORE_PLAYBACK;
                if (a == i.BUFFER) return j.BUFFERING_BEFORE_PLAYBACK
              } else if (f == j.PLAYBACK_NOT_STARTED) {
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.SEEK_START) return j.SEEKING_BEFORE_PLAYBACK;
                if (a == i.BUFFER) return j.BUFFERING_BEFORE_PLAYBACK;
                if (a == i.END || a == i.AD_SKIP) return j.IDLE
              } else if (f == j.PLAYING) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.BUFFER) return j.BUFFERING_DURING_PLAYBACK;
                if (a == i.PAUSE) return j.PAUSED;
                if (a == i.SEEK_START) return j.SEEKING_DURING_PLAYBACK
              } else if (f == j.PAUSED) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.BUFFER) return j.BUFFERING_DURING_PAUSE;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.SEEK_START) return j.SEEKING_DURING_PAUSE
              } else if (f == j.BUFFERING_BEFORE_PLAYBACK) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PAUSE || a == i.BUFFER_STOP) return j.PLAYBACK_NOT_STARTED;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.SEEK_START) return j.SEEKING_BEFORE_PLAYBACK
              } else if (f == j.BUFFERING_DURING_PLAYBACK) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PLAY || a == i.BUFFER_STOP) return j.PLAYING;
                if (a == i.PAUSE_ON_BUFFERING) return j.PAUSED_DURING_BUFFERING;
                if (a == i.SEEK_START) return j.SEEKING_DURING_BUFFERING;
                if (a == i.PAUSE) return j.PAUSED
              } else if (f == j.BUFFERING_DURING_SEEKING) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.BUFFER_STOP) return j.SEEKING_DURING_PLAYBACK;
                if (a == i.PAUSE) return j.PAUSED
              } else if (f == j.BUFFERING_DURING_PAUSE) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.SEEK_START) return j.SEEKING_DURING_PAUSE;
                if (a == i.BUFFER_STOP || a == i.PAUSE) return j.PAUSED
              } else if (f == j.SEEKING_BEFORE_PLAYBACK) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PAUSE) return j.PLAYBACK_NOT_STARTED;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.BUFFER) return j.BUFFERING_BEFORE_PLAYBACK
              } else if (f == j.SEEKING_DURING_PLAYBACK) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.PAUSE) return j.PAUSED;
                if (a == i.BUFFER) return j.BUFFERING_DURING_SEEKING
              } else if (f == j.SEEKING_DURING_BUFFERING) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.PAUSE || a == i.BUFFER_STOP) return j.PAUSED
              } else if (f == j.SEEKING_DURING_PAUSE) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.PLAY) return j.PLAYING;
                if (a == i.PAUSE || a == i.BUFFER_STOP) return j.PAUSED;
                if (a == i.BUFFER) return j.BUFFERING_DURING_PAUSE
              } else if (f == j.PAUSED_DURING_BUFFERING) {
                if (a == i.END || a == i.AD_SKIP) return j.IDLE;
                if (a == i.SEEK_START) return j.SEEKING_DURING_BUFFERING;
                if (a == i.PAUSE) return j.PAUSED;
                if (a == i.PLAY || a == i.BUFFER_STOP) return j.PLAYING
              }
              return null
            },
            getCurrentState: function() {
              return f
            },
            newEvent: function(a, b) {
              var c = g.eventTypeToState(a);
              f != c && (e = f, f = c, d = b)
            },
            getPreviousState: function() {
              return e
            },
            getLastStateChangeTimestamp: function() {
              return d
            }
          }), c()
        }
      }(),
      s = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onSeekStartWhenPausedOrBufferingDuringPause: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() ? a.getPlaylist().getClip().isCollectingSeekingTime() || (a.getPlaylist().getClip().setSeekingTimestamp(b), a.getPlaylist().getClip().setCollectingSeekingTime(!0)) : a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().isSeeking() || (a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b))
            },
            onBufferWhenSeekingOrPlayBackNotStartedOrPaused: function(b, c) {
              a.getPlaylist().setBufferingTimestamp(b), a.getPlaylist().getClip().setBufferingTimestamp(b)
            },
            onPlayWhenSeekingDuringBufferingOrSeekingDuringPause: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            },
            onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b)
            },
            onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause: function(b, c) {
              a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            },
            onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause: function(c, d) {
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getPlaylist().getClip().addElapsedTime(c);
              var e = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(e), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause: function(b, c) {
              a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            }
          })
        }
      }(),
      t = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              a.getPlaylist().addBufferingTime(c), a.getPlaylist().getClip().addBufferingTime(c), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onBufferStop: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            },
            onSeekStart: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() ? a.getPlaylist().getClip().isCollectingSeekingTime() || (a.getPlaylist().getClip().setSeekingTimestamp(b), a.getPlaylist().getClip().setCollectingSeekingTime(!0)) : a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().isSeeking() || (a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b))
            },
            onPause: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().isPlaylistStarted() || (a.getPlaylist().setPlaylistStarted(!0), a.getPlaylist().incrementPlaybackCounter()), a.getPlaylist().getClip().setClipStarted(!0), a.getPlaylist().getClip().setPlaybackStarted(!0), a.getPlaylist().getClip().incrementSegmentPlaybackCounter(), (0 == a.getPlaylist().getClip().getLowestPartNumberPlayed() || parseInt(a.getPlaylist().getClip().getLabels().ns_st_pn) <= a.getPlaylist().getClip().getLowestPartNumberPlayed()) && (a.getPlaylist().getClip().setLowestPartNumberPlayed(parseInt(a.getPlaylist().getClip().getLabels().ns_st_pn)), a.getPlaylist().getClip().incrementAssetPlaybackCounter(), a.getPlaylist().getClip().resetAssetPlaybackCounters()), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getSSECore().isLoadingTimeSent() || (c.ns_st_lt = String(a.getSSECore().getLoadTimeOffset() + b - a.getSSECore().getInitTimestamp()), a.getSSECore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      u = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndAndSkip: function(c, d) {
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getPlaylist().addBufferingTime(c), a.getPlaylist().getClip().addBufferingTime(c), a.getPlaylist().getClip().addElapsedTime(c);
              var e = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(e), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onPause: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b)
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      v = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onPauseOnBuffering: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getSSECore().stopPausedOnBufferingTimer(), a.getHeartbeat().pause(), a.getSSECore().resetKeepAlive(), a.getPlaylist().addPlaybackTime(b), a.getPlaylist().getClip().addPlaybackTime(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().addInterval(d), a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses();
              var e = a.getSSECore().createLabels(i.PAUSE, c, b);
              a.getEventManager().newEvent(e), a.getPlaylist().setBufferingTimestamp(b), a.getPlaylist().getClip().setBufferingTimestamp(b), a.getPlaylist().getClip().setPlaybackTimeOffset(d)
            },
            onBufferStop: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b)
            },
            onEndOrAdSkip: function(c, d) {
              var e = parseInt(d.ns_st_po);
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getSSECore().stopPausedOnBufferingTimer(), a.getPlaylist().addBufferingTime(c), a.getPlaylist().getClip().addBufferingTime(c), a.getPlaylist().getClip().addPlaybackTime(c), a.getPlaylist().getClip().addElapsedTime(c), a.getPlaylist().getClip().addInterval(e);
              var f = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(f), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onSeekStart: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getSSECore().stopPausedOnBufferingTimer(), a.getPlaylist().addPlaybackTime(b), a.getPlaylist().getClip().addPlaybackTime(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().addInterval(d), a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses();
              var e = a.getSSECore().createLabels(i.PAUSE, c, b);
              a.getEventManager().newEvent(e)
            },
            onPause: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getSSECore().stopPausedOnBufferingTimer(), a.getPlaylist().addPlaybackTime(b), a.getPlaylist().getClip().addPlaybackTime(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().addInterval(d), a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses();
              var e = a.getSSECore().createLabels(i.PAUSE, c, b);
              a.getEventManager().newEvent(e)
            },
            onPlay: function(b, c) {
              a.getSSECore().stopPausedOnBufferingTimer(), a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b)
            }
          })
        }
      }(),
      w = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getSSECore().stopPausedOnBufferingTimer(), a.getPlaylist().addBufferingTime(c), a.getPlaylist().getClip().addBufferingTime(c), a.getPlaylist().getClip().addElapsedTime(c);
              var e = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(e), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onPause: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses(), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      x = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onBuffer: function(b, c) {
              a.getPlaylist().getClip().setSeekingTime(a.getPlaylist().getClip().getSeekingTimeBeforeEnd()), a.getPlaylist().setBufferingTimestamp(b), a.getPlaylist().getClip().setBufferingTimestamp(b)
            },
            onSeekStart: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().setSeekingTime(a.getPlaylist().getClip().getSeekingTimeBeforeEnd()), a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b)
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().setSeekingTime(a.getPlaylist().getClip().getSeekingTimeBeforeEnd()), a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().isPlaylistStarted() || (a.getPlaylist().setPlaylistStarted(!0), a.getPlaylist().incrementPlaybackCounter()), a.getPlaylist().getClip().setClipStarted(!0), a.getPlaylist().getClip().setPlaybackStarted(!0), a.getPlaylist().getClip().incrementSegmentPlaybackCounter(), (0 == a.getPlaylist().getClip().getLowestPartNumberPlayed() || parseInt(a.getPlaylist().getClip().getLabel("ns_st_pn")) <= a.getPlaylist().getClip().getLowestPartNumberPlayed()) && (a.getPlaylist().getClip().setLowestPartNumberPlayed(parseInt(a.getPlaylist().getClip().getLabel("ns_st_pn"))), a.getPlaylist().getClip().incrementAssetPlaybackCounter(), a.getPlaylist().getClip().resetAssetPlaybackCounters()), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getSSECore().isLoadingTimeSent() || (c.ns_st_lt = String(a.getSSECore().getLoadTimeOffset() + b - a.getSSECore().getInitTimestamp()), a.getSSECore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      y = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getPlaylist().getClip().addElapsedTime(c);
              var e = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(e), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      z = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getPlaylist().addBufferingTime(c), a.getPlaylist().getClip().addBufferingTime(c), a.getPlaylist().getClip().addElapsedTime(c);
              var e = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(e), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onBufferStop: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            },
            onSeekStart: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().isSeeking() ? a.getPlaylist().getClip().isCollectingSeekingTime() || (a.getPlaylist().getClip().setSeekingTimestamp(b), a.getPlaylist().getClip().setCollectingSeekingTime(!0)) : a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().isSeeking() || (a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b))
            },
            onPause: function(b, c) {
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses()
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().addBufferingTime(b), a.getPlaylist().getClip().addBufferingTime(b), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      A = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onSeekStart: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() ? a.getPlaylist().getClip().setSeekingTimestamp(b) : a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().isSeeking() || (a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b))
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().isPlaylistStarted() || (a.getPlaylist().setPlaylistStarted(!0), a.getPlaylist().incrementPlaybackCounter()), a.getPlaylist().getClip().setClipStarted(!0), a.getPlaylist().getClip().setPlaybackStarted(!0), a.getPlaylist().getClip().incrementSegmentPlaybackCounter(), (0 == a.getPlaylist().getClip().getLowestPartNumberPlayed() || parseInt(a.getPlaylist().getClip().getLabels().ns_st_pn) <= a.getPlaylist().getClip().getLowestPartNumberPlayed()) && (a.getPlaylist().getClip().setLowestPartNumberPlayed(parseInt(a.getPlaylist().getClip().getLabels().ns_st_pn)), a.getPlaylist().getClip().incrementAssetPlaybackCounter(), a.getPlaylist().getClip().resetAssetPlaybackCounters()), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getSSECore().isLoadingTimeSent() || (c.ns_st_lt = String(a.getSSECore().getLoadTimeOffset() + b - a.getSSECore().getInitTimestamp()), a.getSSECore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      B = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              var e = parseInt(d.ns_st_po);
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getPlaylist().addPlaybackTime(c), a.getPlaylist().getClip().addPlaybackTime(c), a.getPlaylist().getClip().addElapsedTime(c), a.getPlaylist().getClip().addInterval(e);
              var f = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(f), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onBuffer: function(b, c) {
              a.getSSECore().isPauseOnBufferingEnabled() && a.getSSECore().startPausedOnBufferingTimer(b, c), a.getPlaylist().getClip().incrementBufferCount(), a.getPlaylist().setBufferingTimestamp(b), a.getPlaylist().getClip().setBufferingTimestamp(b)
            },
            onSeekStart: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getHeartbeat().pause(), a.getSSECore().resetKeepAlive(), a.getPlaylist().addPlaybackTime(b), a.getPlaylist().getClip().addPlaybackTime(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().addInterval(d), a.getPlaylist().getClip().incrementSeeks(), a.getPlaylist().getClip().setSeeking(!0), a.getPlaylist().getClip().setCollectingSeekingTime(!0), a.getPlaylist().getClip().setSeekStartPosition(d), a.getPlaylist().getClip().setSeekingTimestamp(b), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses();
              var e = a.getSSECore().createLabels(i.PAUSE, c, b);
              a.getEventManager().newEvent(e)
            },
            onPause: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getHeartbeat().pause(), a.getSSECore().resetKeepAlive(), a.getPlaylist().addPlaybackTime(b), a.getPlaylist().getClip().addPlaybackTime(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().addInterval(d), a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses();
              var e = a.getSSECore().createLabels(i.PAUSE, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      C = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onPause: function(b, c) {
              a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().isPlaylistStarted() || (a.getPlaylist().setPlaylistStarted(!0), a.getPlaylist().incrementPlaybackCounter()), a.getPlaylist().getClip().setClipStarted(!0), a.getPlaylist().getClip().setPlaybackStarted(!0), a.getPlaylist().getClip().incrementSegmentPlaybackCounter(), (0 == a.getPlaylist().getClip().getLowestPartNumberPlayed() || parseInt(a.getPlaylist().getClip().getLabels().ns_st_pn) <= a.getPlaylist().getClip().getLowestPartNumberPlayed()) && (a.getPlaylist().getClip().setLowestPartNumberPlayed(parseInt(a.getPlaylist().getClip().getLabels().ns_st_pn)), a.getPlaylist().getClip().incrementAssetPlaybackCounter(), a.getPlaylist().getClip().resetAssetPlaybackCounters()), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getSSECore().isLoadingTimeSent() || (c.ns_st_lt = String(a.getSSECore().getLoadTimeOffset() + b - a.getSSECore().getInitTimestamp()), a.getSSECore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      D = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onPause: function(b, c) {
              a.getPlaylist().incrementPauses(), a.getPlaylist().getClip().incrementPauses(), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1))
            }
          })
        }
      }(),
      E = function() {
        return function(a) {
          var c = this;
          b.extend(c, {
            onEndOrAdSkip: function(c, d) {
              parseInt(d.ns_st_po);
              a.getSSECore().resetHeartbeat(), a.getSSECore().resetKeepAlive(), a.getPlaylist().getClip().addElapsedTime(c);
              var e = a.getSSECore().createLabels(i.END, d, c);
              a.getEventManager().newEvent(e), a.getPlaylist().getClip().isSeeking() && a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().setSeekingTimeBeforeEnd(c - a.getPlaylist().getClip().getSeekingTimestamp()), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().storeClipPlaybackCounters(), a.getPlaylist().getClip().resetClipLifecycleLabels(), a.getPlaylist().getClip().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getSSECore().resetPlaylist()
            },
            onPlay: function(b, c) {
              var d = parseInt(c.ns_st_po);
              a.getPlaylist().getClip().isSeeking() && (a.getPlaylist().getClip().isCollectingSeekingTime() && (a.getPlaylist().getClip().addSeekingTime(b), a.getPlaylist().getClip().setCollectingSeekingTime(!1)), a.getPlaylist().getClip().addSeekingAmount(d), a.getPlaylist().getClip().setSeeking(!1)), a.getPlaylist().getClip().incrementPlayCounter(), a.getPlaylist().setPlaybackTimestamp(b), a.getPlaylist().getClip().setPlaybackTimestamp(b), a.getPlaylist().getClip().addElapsedTime(b), a.getPlaylist().getClip().setElapsedTimestamp(b), a.getPlaylist().getClip().setPlaybackStartPosition(d), a.getSSECore().isLoadingTimeSent() || (c.ns_st_lt = String(a.getSSECore().getLoadTimeOffset() + b - a.getSSECore().getInitTimestamp()), a.getSSECore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().resume();
              var e = a.getSSECore().createLabels(i.PLAY, c, b);
              a.getEventManager().newEvent(e)
            }
          })
        }
      }(),
      F = function() {
        return function() {
          function a() {
            f = new G(aa), b.getNamespace().comScore ? (ba = b.getNamespace().comScore.exports, f.setAppCore(ba.c())) : f.setAppCore(null), f.setKeepAlive(new q(f)),
              f.setHeartbeat(new p(f)), f.setEventManager(new o(f)), f.setStateMachine(new r), f.setPlaylist(new n), $ = {}, m = new x(f), F = new y(f), H = new A(f), I = new B(f), J = new t(f), K = new v(f), L = new w(f), M = new u(f), N = new z(f), O = new C(f), P = new D(f), Q = new E(f), R = new s(f), S = !1, T = 0, U = +new Date, V = !0, X = !1, Z = []
          }

          function c(a) {
            var b = f.getStateMachine().getCurrentState();
            if (b == j.IDLE || b == j.PLAYBACK_NOT_STARTED || b == j.BUFFERING_BEFORE_PLAYBACK || b == j.SEEKING_BEFORE_PLAYBACK) {
              if (a == i.PLAY) return !0
            } else if (b == j.PLAYING) {
              if (a == i.END || a == i.AD_SKIP || a == i.SEEK_START || a == i.PAUSE) return !0
            } else if (b == j.PAUSED || b == j.BUFFERING_DURING_PAUSE || b == j.SEEKING_DURING_PLAYBACK || b == j.SEEKING_DURING_BUFFERING || b == j.SEEKING_DURING_PAUSE) {
              if (a == i.END || a == i.AD_SKIP || a == i.PLAY) return !0
            } else if (b == j.BUFFERING_DURING_PLAYBACK) {
              if (a == i.PAUSE_ON_BUFFERING || a == i.END || a == i.AD_SKIP || a == i.SEEK_START || a == i.PAUSE || a == i.PLAY) return !0
            } else if (b == j.BUFFERING_DURING_SEEKING) {
              if (a == i.END || a == i.AD_SKIP || a == i.PAUSE || a == i.PLAY) return !0
            } else if (b == j.PAUSED_DURING_BUFFERING && (a == i.END || a == i.AD_SKIP || a == i.BUFFER_STOP || a == i.PLAY)) return !0;
            return !1
          }

          function d(a, b, d) {
            var e = f.getStateMachine().getCurrentState();
            a == i.AD_SKIP && !d.hasOwnProperty("ns_st_ui") && c(a) ? d.ns_st_ui = "skip" : a == i.SEEK_START && !d.hasOwnProperty("ns_st_ui") && c(a) && (d.ns_st_ui = "seek"), e == j.IDLE ? a == i.BUFFER ? m.onBuffer(b, d) : a == i.SEEK_START ? m.onSeekStart(b, d) : a == i.PLAY && m.onPlay(b, d) : e == j.PLAYBACK_NOT_STARTED ? a == i.END || a == i.AD_SKIP ? H.onEndOrAdSkip(b, d) : a == i.SEEK_START ? H.onSeekStart(b, d) : a == i.PLAY ? H.onPlay(b, d) : a == i.BUFFER && R.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, d) : e == j.PLAYING ? a == i.END || a == i.AD_SKIP ? I.onEndOrAdSkip(b, d) : a == i.BUFFER ? I.onBuffer(b, d) : a == i.SEEK_START ? I.onSeekStart(b, d) : a == i.PAUSE && I.onPause(b, d) : e == j.PAUSED ? a == i.END || a == i.AD_SKIP ? F.onEndOrAdSkip(b, d) : a == i.PLAY ? F.onPlay(b, d) : a == i.BUFFER ? R.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, d) : a == i.SEEK_START && R.onSeekStartWhenPausedOrBufferingDuringPause(b, d) : e == j.BUFFERING_BEFORE_PLAYBACK ? a == i.END || a == i.AD_SKIP ? J.onEndOrAdSkip(b, d) : a == i.BUFFER_STOP ? J.onBufferStop(b, d) : a == i.SEEK_START ? J.onSeekStart(b, d) : a == i.PAUSE ? J.onPause(b, d) : a == i.PLAY && J.onPlay(b, d) : e == j.BUFFERING_DURING_PLAYBACK ? a == i.PAUSE_ON_BUFFERING ? K.onPauseOnBuffering(b, d) : a == i.BUFFER_STOP ? K.onBufferStop(b, d) : a == i.END || a == i.AD_SKIP ? K.onEndOrAdSkip(b, d) : a == i.SEEK_START ? K.onSeekStart(b, d) : a == i.PAUSE ? K.onPause(b, d) : a == i.PLAY && K.onPlay(b, d) : e == j.BUFFERING_DURING_SEEKING ? a == i.END || a == i.AD_SKIP ? L.onEndOrAdSkip(b, d) : a == i.PAUSE ? L.onPause(b, d) : a == i.PLAY ? L.onPlay(b, d) : a == i.BUFFER_STOP && R.onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause(b, d) : e == j.BUFFERING_DURING_PAUSE ? a == i.END || a == i.AD_SKIP ? M.onEndAndSkip(b, d) : a == i.PAUSE ? M.onPause(b, d) : a == i.PLAY ? M.onPlay(b, d) : a == i.SEEK_START ? R.onSeekStartWhenPausedOrBufferingDuringPause(b, d) : a == i.BUFFER_STOP && R.onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause(b, d) : e == j.SEEKING_BEFORE_PLAYBACK ? a == i.END || a == i.AD_SKIP ? O.onEndOrAdSkip(b, d) : a == i.PAUSE ? O.onPause(b, d) : a == i.PLAY ? O.onPlay(b, d) : a == i.BUFFER && R.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, d) : e == j.SEEKING_DURING_PLAYBACK ? a == i.END || a == i.AD_SKIP ? Q.onEndOrAdSkip(b, d) : a == i.PLAY ? Q.onPlay(b, d) : a == i.BUFFER ? R.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, d) : a == i.PAUSE && R.onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause(b, d) : e == j.SEEKING_DURING_BUFFERING ? a == i.PAUSE ? P.onPause(b, d) : a == i.BUFFER ? R.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, d) : a == i.PLAY ? R.onPlayWhenSeekingDuringBufferingOrSeekingDuringPause(b, d) : a == i.END || a == i.AD_SKIP ? R.onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause(b, d) : a == i.BUFFER_STOP && R.onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause(b, d) : e == j.PAUSED_DURING_BUFFERING ? a == i.END || a == i.AD_SKIP ? N.onEndOrAdSkip(b, d) : a == i.BUFFER_STOP ? N.onBufferStop(b, d) : a == i.SEEK_START ? N.onSeekStart(b, d) : a == i.PAUSE ? N.onPause(b, d) : a == i.PLAY && N.onPlay(b, d) : e == j.SEEKING_DURING_PAUSE && (a == i.BUFFER ? R.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, d) : a == i.PLAY ? R.onPlayWhenSeekingDuringBufferingOrSeekingDuringPause(b, d) : a == i.PAUSE ? R.onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause(b, d) : a == i.END || a == i.AD_SKIP ? R.onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause(b, d) : a == i.BUFFER_STOP && R.onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause(b, d)), c(a) && f.getPlaylist().setFirstEventSent(!0)
          }

          function e(a, c) {
            for (var d, e = ea.encodeURIComponent || escape, f = [], g = l.LABELS_ORDER, h = a.split("?"), i = h[0], j = h[1], k = j.split("&"), m = 0, n = k.length; n > m; m++) {
              var o = k[m].split("="),
                p = unescape(o[0]),
                q = unescape(o[1]);
              p && (c[p] = q)
            }
            for (var r = {}, s = 0, t = g.length; t > s; s++) {
              var u = g[s];
              if (c.hasOwnProperty(u)) {
                var v = c[u];
                "undefined" != typeof v && null != v && (r[u] = !0, f.push(e(u) + "=" + e(c[u])))
              }
            }
            for (var w in c)
              if (c.hasOwnProperty(w)) {
                if (r[w]) continue;
                var x = c[w];
                "undefined" != typeof x && null != x && f.push(e(w) + "=" + e(c[w]))
              }
            d = i + "?" + f.join("&"), d = d + (d.indexOf("&c8=") < 0 ? "&c8=" + e(fa.title) : "") + (d.indexOf("&c7=") < 0 ? "&c7=" + e(fa.URL) : "") + (d.indexOf("&c9=") < 0 ? "&c9=" + e(fa.referrer) : "");
            var y = b.browserAcceptsLargeURLs() ? l.URL_LENGTH_LIMIT : l.RESTRICTED_URL_LENGTH_LIMIT;
            if (d.length > y && d.indexOf("&") > 0) {
              var z = d.substr(0, y - 8).lastIndexOf("&");
              d = (d.substring(0, z) + "&ns_cut=" + e(d.substring(z + 1))).substr(0, y)
            }
            return d
          }
          var f, m, F, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, _, aa = this,
            ba = {},
            ca = l.DEFAULT_PAUSED_ON_BUFFERING_INTERVAL,
            da = l.THROTTLING_DELAY;
          b.extend(aa, {
            createLabels: function(a, c, d) {
              var e = {};
              if ("undefined" != typeof document) {
                var g = document;
                e.c7 = g.URL, e.c8 = g.title, e.c9 = g.referrer
              }
              return null != c && b.extend(e, c), e.ns_ts = null != e.ns_ts ? e.ns_ts : String(+new Date), e.ns_st_ev = null != e.ns_st_ev ? e.ns_st_ev : i.toString(a), e.ns_st_mp = null != e.ns_st_mp ? e.ns_st_mp : l.DEFAULT_PLAYERNAME, e.ns_st_mv = null != e.ns_st_mv ? e.ns_st_mv : l.STREAMSENSE_VERSION, e.ns_st_ub = null != e.ns_st_ub ? e.ns_st_ub : "0", e.ns_st_br = null != e.ns_st_br ? e.ns_st_br : "0", e.ns_st_pn = null != e.ns_st_pn ? e.ns_st_pn : "1", e.ns_st_tp = null != e.ns_st_tp ? e.ns_st_tp : "1", e.ns_st_it = null != e.ns_st_it ? e.ns_st_it : k.toString(k.SINGLE_CLIP), e.ns_st_sv = null != e.ns_st_sv ? e.ns_st_sv : l.STREAMSENSE_VERSION, e.ns_st_smv = null != e.ns_st_smv ? e.ns_st_smv : l.MODEL_VERSION, e.ns_type = null != e.ns_type ? e.ns_type : "hidden", e.ns_st_ec = null != e.ns_st_ec ? e.ns_st_ec : String(f.getEventManager().getEventCounter()), e.ns_st_po = null != e.ns_st_po ? e.ns_st_po : String(f.getPlaylist().getPlaylist().getClip().getExpectedPlaybackPosition(d)), e.ns_st_ki = null != e.ns_st_ki ? e.ns_st_ki : String(f.getKeepAlive().getInterval()), f.getPlaylist().createLabels(e), f.getPlaylist().getClip().createLabels(e), b.extend(e, aa.getLabels()), b.extend(e, c), {
                eventType: a,
                eventLabels: e
              }
            },
            newEvent: function(a, b, c, e) {
              aa.stopDelayedTransitionTimer();
              var g = f.getStateMachine().getCurrentState(),
                h = f.getStateMachine().eventTypeToState(a);
              if (null != h && h != g)
                if (!aa.isThrottlingEnabled() || g != j.PLAYING && g != j.PAUSED || h != j.PLAYING && h != j.PAUSED || e) {
                  c.ns_st_po || (f.getStateMachine().getCurrentState() == j.PLAYING && a == i.BUFFER || f.getStateMachine().getCurrentState() == j.BUFFERING_DURING_PLAYBACK && a == i.BUFFER_STOP ? c.ns_st_po = String(f.getPlaylist().getClip().getPlaybackTimeOffset() + (b - f.getPlaylist().getClip().getPlaybackTimestamp())) : c.ns_st_po = String(f.getPlaylist().getClip().getExpectedPlaybackPosition(b))), d(a, b, c);
                  var k = 0;
                  isNaN(f.getStateMachine().getLastStateChangeTimestamp()) || (k = b - f.getStateMachine().getLastStateChangeTimestamp()), f.getStateMachine().newEvent(a, b);
                  for (var l = 0, m = Z.length; m > l; l++) Z[l](g, h, c, k)
                } else Y = f.getPlatformAPI().setTimeout(function(a, c, d) {
                  return function() {
                    aa.newEvent(a, b, d, !0)
                  }
                }(a, h, c), da)
            },
            newPseudoEvent: function(a, b, c) {
              if (a != i.LOAD && a != i.START || f.getStateMachine().getCurrentState() == j.IDLE) {
                a != i.ERROR || c.ns_st_er || (c.ns_st_er = h.UNKNOWN_VALUE), f.getStateMachine().getCurrentState() != j.IDLE && f.getStateMachine().getCurrentState() != j.PLAYBACK_NOT_STARTED && f.getStateMachine().getCurrentState() != j.SEEKING_BEFORE_PLAYBACK && f.getStateMachine().getCurrentState() != j.BUFFERING_BEFORE_PLAYBACK && (f.getPlaylist().getClip().addElapsedTime(b), f.getPlaylist().getClip().setElapsedTimestamp(b));
                var d, e, g, k = !0,
                  l = !1;
                switch (a) {
                  case i.BIT_RATE:
                    d = "ns_st_br", e = "ns_st_pbr", l = !0;
                    break;
                  case i.PLAYBACK_RATE:
                    d = "ns_st_rt", e = "ns_st_prt", l = !0;
                    break;
                  case i.VOLUME:
                    d = "ns_st_vo", e = "ns_st_pvo", l = !0;
                    break;
                  case i.WINDOW_STATE:
                    d = "ns_st_ws", e = "ns_st_pws", l = !0;
                    break;
                  case i.AUDIO:
                    d = "ns_st_at", e = "ns_st_pat", l = !1;
                    break;
                  case i.VIDEO:
                    d = "ns_st_vt", e = "ns_st_pvt", l = !1;
                    break;
                  case i.SUBS:
                    d = "ns_st_tt", e = "ns_st_ptt", l = !1;
                    break;
                  case i.CDN:
                    d = "ns_st_cdn", e = "ns_st_pcdn", l = !1;
                    break;
                  default:
                    k = !1
                }
                if (k && c.hasOwnProperty(d) && (l ? (aa.getLabels().hasOwnProperty(d) && (g = aa.getLabels()[d], c[e] = g), aa.setLabel(d, c[d])) : (f.getPlaylist().getClip().getLabels().hasOwnProperty(d) && (g = f.getPlaylist().getClip().getLabels()[d], c[e] = g), f.getPlaylist().getClip().setLabel(d, c[d]))), !k || f.getStateMachine().getCurrentState() == j.PLAYING || f.getStateMachine().getCurrentState() == j.BUFFERING_DURING_PLAYBACK) {
                  c.ns_st_po || (c.ns_st_po = String(f.getPlaylist().getClip().getExpectedPlaybackPosition(b))), f.getStateMachine().getCurrentState() != j.PLAYING && f.getStateMachine().getCurrentState() != j.BUFFERING_DURING_PLAYBACK || (f.getPlaylist().addPlaybackTime(b), f.getPlaylist().setPlaybackTimestamp(b), f.getPlaylist().getClip().addPlaybackTime(b), f.getPlaylist().getClip().setPlaybackTimestamp(b), f.getPlaylist().getClip().addInterval(parseInt(c.ns_st_po)), f.getPlaylist().getClip().setPlaybackStartPosition(parseInt(c.ns_st_po))), f.getStateMachine().getCurrentState() != j.BUFFERING_BEFORE_PLAYBACK && f.getStateMachine().getCurrentState() != j.BUFFERING_DURING_PAUSE && f.getStateMachine().getCurrentState() != j.BUFFERING_DURING_PLAYBACK && f.getStateMachine().getCurrentState() != j.BUFFERING_DURING_SEEKING || (f.getPlaylist().addBufferingTime(b), f.getPlaylist().setBufferingTimestamp(b), f.getPlaylist().getClip().addBufferingTime(b), f.getPlaylist().getClip().setBufferingTimestamp(b));
                  var m = aa.createLabels(a, c, b);
                  f.getEventManager().newEvent(m)
                }
              }
            },
            getState: function() {
              return f.getStateMachine().getCurrentState()
            },
            addListener: function(a) {
              Z.push(a)
            },
            removeListener: function(a) {
              Z.splice(b.indexOf(a, Z), 1)
            },
            getLabel: function(a) {
              return $[a]
            },
            getLabels: function() {
              return $
            },
            setLabel: function(a, b) {
              null == b ? delete $[a] : $[a] = b
            },
            setLabels: function(a) {
              for (var b in a) a.hasOwnProperty(b) && aa.setLabel(b, a[b])
            },
            getPlatformAPI: function() {
              return f.getAppCore() ? f.getAppCore().getPlatformAPI() : g
            },
            getExports: function() {
              return ba
            },
            isProperlyInitialized: function() {
              var a = f.getAppCore().getAppContext(),
                b = f.getAppCore().getSalt(),
                c = f.getAppCore().getPixelURL();
              return a && c && b
            },
            setImplementationType: function(a) {
              f.getStateMachine().getCurrentState() != j.IDLE || a != k.SINGLE_CLIP && a != k.SEGMENTED && a != k.REDUCED || f.getPlaylist().setLabel("ns_st_it", k.toString(a))
            },
            setThrottlingDelay: function(a) {
              da = a
            },
            getThrottlingDelay: function() {
              return da
            },
            isThrottlingEnabled: function() {
              return X
            },
            setThrottlingEnabled: function(a) {
              X = a
            },
            isLoadingTimeSent: function() {
              return S
            },
            setLoadingTimeSent: function(a) {
              S = a
            },
            getLoadTimeOffset: function() {
              return T
            },
            setLoadTimeOffset: function(a) {
              T = a
            },
            getInitTimestamp: function() {
              return U
            },
            setPauseOnBufferingInterval: function(a) {
              ca = a
            },
            getPauseOnBufferingInterval: function() {
              return ca
            },
            isPauseOnBufferingEnabled: function() {
              return V
            },
            setPauseOnBufferingEnabled: function(a) {
              V = a
            },
            startPausedOnBufferingTimer: function(a, c) {
              aa.stopPausedOnBufferingTimer(), W = aa.getPlatformAPI().setTimeout(function() {
                var d = {},
                  e = b.fixEventTime(d),
                  f = parseInt(c.ns_st_po);
                d.ns_st_po = String(f + e - a), aa.newEvent(i.PAUSE_ON_BUFFERING, e, d)
              }, ca)
            },
            stopPausedOnBufferingTimer: function() {
              null != W && (aa.getPlatformAPI().clearTimeout(W), W = null)
            },
            stopDelayedTransitionTimer: function() {
              Y && (aa.getPlatformAPI().clearTimeout(Y), Y = null)
            },
            setPixelURL: function(a) {
              if (null == a || 0 == a.length) return null;
              var b = decodeURIComponent || unescape,
                c = a.indexOf("?");
              if (c >= 0) {
                if (c < a.length - 1) {
                  for (var d = a.substring(c + 1).split("&"), e = 0, f = d.length; f > e; e++) {
                    var g = d[e],
                      h = g.split("=");
                    2 == h.length ? aa.setLabel(h[0], b(h[1])) : 1 == h.length && aa.setLabel(l.PAGE_NAME_LABEL, b(h[0]))
                  }
                  a = a.substring(0, c + 1)
                }
              } else a += "?";
              return _ = a
            },
            getPixelURL: function() {
              return _ ? _ : "undefined" != typeof ns_p && "string" == typeof ns_p.src ? _ = ns_p.src.replace(/&/, "&").replace(/&ns__t=\d+/, "") : "string" == typeof ns_pixelUrl ? _ = ns_pixelUrl.replace(/&/, "&").replace(/&ns__t=\d+/, "") : null
            },
            getSseSM: function() {
              return f
            },
            resetPlaylist: function(a) {
              var b = f.getPlaylist();
              f.setPlaylist(new n), n.resetPlaylist(b, f.getPlaylist(), a)
            },
            resetHeartbeat: function() {
              f.getHeartbeat().pause(), f.setHeartbeat(new p(f))
            },
            resetKeepAlive: function() {
              f.getKeepAlive().pause(), f.setKeepAlive(new q(f))
            }
          });
          var ea, fa;
          b.isBrowser() ? (ea = window, fa = document) : (ea = {}, fa = {
            location: {
              href: ""
            },
            title: "",
            URL: "",
            referrer: "",
            cookie: ""
          }), b.extend(this, {
            prepareUrl: e
          }), a()
        }
      }(),
      G = function() {
        return function(a) {
          var c, d, e, f, g, h, i = this;
          b.extend(i, {
            getAppCore: function() {
              return c
            },
            getSSECore: function() {
              return a
            },
            getEventManager: function() {
              return d
            },
            getStateMachine: function() {
              return e
            },
            getHeartbeat: function() {
              return f
            },
            getKeepAlive: function() {
              return g
            },
            getPlaylist: function() {
              return h
            },
            setAppCore: function(a) {
              c = a
            },
            setKeepAlive: function(a) {
              g = a
            },
            setHeartbeat: function(a) {
              f = a
            },
            setEventManager: function(a) {
              d = a
            },
            setStateMachine: function(a) {
              e = a
            },
            setPlaylist: function(a) {
              h = a
            }
          })
        }
      }(),
      H = function() {
        return function(a, c) {
          function d() {
            h = new F, g = !0, a && k.setLabels(a), c && k.setPixelURL(c)
          }

          function e(a, b) {
            k.notify(i.CUSTOM, a, b)
          }

          function f() {
            g && h.getSseSM().getStateMachine().getCurrentState() != j.IDLE && k.end()
          }
          var g, h, k = this,
            m = l.STANDARD_METADATA_LABELS;
          b.extend(this, {
            isProperlyInitialized: function() {
              return h.isProperlyInitialized()
            },
            reset: function(a) {
              var b = h;
              b.getSseSM().getKeepAlive().pause(), b.getSseSM().getHeartbeat().pause(), h = new F, n.resetPlaylist(b.getSseSM().getPlaylist(), h.getSseSM().getPlaylist(), a)
            },
            setPauseOnBufferingInterval: function(a) {
              h.setPauseOnBufferingInterval(a)
            },
            getPauseOnBufferingInterval: function() {
              return h.getPauseOnBufferingInterval()
            },
            setKeepAliveInterval: function(a) {
              h.getSseSM().getKeepAlive().setInterval(a)
            },
            getKeepAliveInterval: function() {
              return h.getSseSM().getKeepAlive().getInterval()
            },
            setHeartbeatIntervals: function(a) {
              h.getSseSM().getHeartbeat().setIntervals(a)
            },
            play: function(a, b) {
              k.notify(i.PLAY, a, b)
            },
            pause: function(a, b) {
              k.notify(i.PAUSE, a, b)
            },
            end: function(a, b) {
              k.notify(i.END, a, b)
            },
            bufferStart: function(a, b) {
              k.notify(i.BUFFER, a, b)
            },
            bufferStop: function(a, b) {
              k.notify(i.BUFFER_STOP, a, b)
            },
            load: function(a, b) {
              k.notify(i.LOAD, a, b)
            },
            start: function(a, b) {
              k.notify(i.START, a, b)
            },
            seekStart: function(a, b) {
              k.notify(i.SEEK_START, a, b)
            },
            skipAd: function(a, b) {
              k.notify(i.AD_SKIP, a, b)
            },
            callToAction: function(a, b) {
              k.notify(i.CTA, a, b)
            },
            error: function(a, b) {
              k.notify(i.ERROR, a, b)
            },
            transferPlayback: function(a, b) {
              k.notify(i.TRANSFER, a, b)
            },
            drmFail: function(a, b) {
              k.notify(i.DRM_FAILED, a, b)
            },
            drmApprove: function(a, b) {
              k.notify(i.DRM_APPROVED, a, b)
            },
            drmDeny: function(a, b) {
              k.notify(i.DRM_DENIED, a, b)
            },
            changeBitrate: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_br = String(a), k.notify(i.BIT_RATE, d, b)
              }
            },
            changePlaybackRate: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_rt = String(a), k.notify(i.PLAYBACK_RATE, d, b)
              }
            },
            changeVolume: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_vo = String(a), k.notify(i.VOLUME, d, b)
              }
            },
            changeWindowState: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_ws = String(a), k.notify(i.WINDOW_STATE, d, b)
              }
            },
            changeAudio: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_at = String(a), k.notify(i.AUDIO, d, b)
              }
            },
            changeVideo: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_vt = String(a), k.notify(i.VIDEO, d, b)
              }
            },
            changeSubtitle: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_tt = String(a), k.notify(i.SUBS, d, b)
              }
            },
            changeCDN: function(a, b, c) {
              if (null != a) {
                var d = c || {};
                d.ns_st_cdn = String(a), k.notify(i.CDN, d, b)
              }
            },
            notify: function(a) {
              var c, d;
              if (c = "object" == typeof arguments[1] ? arguments[1] : "object" == typeof arguments[2] ? arguments[2] : {}, d = "number" == typeof arguments[1] ? arguments[1] : "number" == typeof arguments[2] ? arguments[2] : NaN, i.toString(a)) {
                c = b.jsonObjectToStringDictionary(c);
                var e = b.fixEventTime(c);
                c.ns_st_po || isNaN(d) || (c.ns_st_po = b.getInteger(d, 0).toString()), c.ns_st_po && h.getSseSM().getPlaylist().getClip().setPlaybackTimeOffset(parseInt(c.ns_st_po)), a == i.PLAY || a == i.PAUSE || a == i.BUFFER || a == i.END || a == i.SEEK_START || a == i.AD_SKIP || a == i.BUFFER_STOP ? h.newEvent(a, e, c) : h.newPseudoEvent(a, e, c)
              }
            },
            getLabels: function() {
              return h.getLabels()
            },
            getState: function() {
              return h.getSseSM().getStateMachine().getCurrentState()
            },
            setLabels: function(a) {
              h.setLabels(a)
            },
            getLabel: function(a) {
              return h.getLabel(a)
            },
            setLabel: function(a, b) {
              h.setLabel(a, b)
            },
            getLoadTimeOffset: function() {
              return h.getLoadTimeOffset()
            },
            setLoadTimeOffset: function(a) {
              h.setLoadTimeOffset(a)
            },
            setPixelURL: function(a) {
              return h.setPixelURL(a)
            },
            getPixelURL: function() {
              return h.getSseSM().getSSECore().getPixelURL()
            },
            setImplementationType: function(a) {
              h.setImplementationType(a)
            },
            isPauseOnBufferingEnabled: function() {
              return h.isPauseOnBufferingEnabled()
            },
            setPauseOnBufferingEnabled: function(a) {
              h.setPauseOnBufferingEnabled(a)
            },
            isThrottlingEnabled: function() {
              return h.isThrottlingEnabled()
            },
            setThrottlingEnabled: function(a) {
              h.setThrottlingEnabled(a)
            },
            setThrottlingDelay: function(a) {
              h.setThrottlingDelay(a)
            },
            getThrottlingDelay: function() {
              return h.getThrottlingDelay()
            },
            setPlaybackIntervalMergeTolerance: function(a) {
              h.getSseSM().getPlaylist().getClip().setPlaybackIntervalMergeTolerance(a)
            },
            getPlaybackIntervalMergeTolerance: function() {
              return h.getSseSM().getPlaylist().getClip().getPlaybackIntervalMergeTolerance()
            },
            setClip: function(a, c, d) {
              if (void 0 === d && (d = !0), a = b.jsonObjectToStringDictionary(a), d && h.getSseSM().getStateMachine().getCurrentState() !== j.IDLE && k.end(), h.getSseSM().getStateMachine().getCurrentState() == j.IDLE) {
                var e = "",
                  f = 0;
                if (null != a.ns_st_cn) e = String(a.ns_st_cn);
                else
                  for (var g = 0; g < m.length; g++) a[m[g]] && (e += m[g] + ":" + a[m[g]] + ";");
                var i = h.getSseSM().getPlaylist(),
                  l = i.getClip();
                l.isClipStarted() ? (i.hashExists(l.getHash()) || (i.storeHash(l.getHash()), i.storeClipNumber(l.getHash(), l.getClipNumber())), i.storeClipPlaybackCounters(), f = i.hashExists(e) ? i.getClipNumber(e) : b.exists(a.ns_st_cn) ? parseInt(a.ns_st_cn) : i.getMaxClipNumber() + 1) : f = i.hashExists(e) ? i.getClipNumber(e) : l.getClipNumber(), i.resetClip(), l = i.getClip(), l.setHash(e), l.setClipNumber(f), l.setLabels(a);
                var n = i.getStoredClipRegisters(e);
                return n && (l.setClipStarted(!0), l.setSegmentPlaybackCounter(n.segmentPlaybackCounter), l.setClipLoadCounter(n.clipLoadCounter), l.setAssetPlaybackCounter(n.assetPlaybackCounter), l.setLowestPartNumberPlayed(n.lowestPartNumberPlayed), l.setSeeking(n.seeking), l.setSeekingTimeBeforeEnd(n.seekingTimeBeforeEnd), l.setSeekStartPosition(n.seekingStartPosition), l.setClipPlaybackIntervals(n.clipPlaybackIntervals), l.setUniquePlaybackInterval(n.uniquePlaybackInterval), l.setLongestPlaybackInterval(n.longestPlaybackInterval), l.setVideoTrack(n.videoTrack), l.setAudioTrack(n.audioTrack), l.setSubtitleTrack(n.subtitleTrack), l.setCDN(n.cdn), l.setPreviousUniquePlaybackInterval(n.uniquePlaybackInterval), l.setPreviousEventIndependentUniquePlaybackInterval(n.uniquePlaybackInterval), l.setPreviousLongestPlaybackInterval(n.longestPlaybackInterval)), l.incrementClipLoadCounter(), l.isClipStarted() && c && (i.incrementPlayCounter(), i.incrementPlaybackCounter()), !0
              }
              return !1
            },
            setPlaylist: function(a, c) {
              return void 0 === c && (c = !0), a = b.jsonObjectToStringDictionary(a), c && h.getSseSM().getStateMachine().getCurrentState() !== j.IDLE && k.end(), h.getSseSM().getStateMachine().getCurrentState() == j.IDLE ? (h.getSseSM().getPlaylist().isPlaylistStarted() && h.resetPlaylist(), h.getSseSM().getPlaylist().setLabels(a), !0) : !1
            },
            importState: function() {},
            exportState: function() {
              return {}
            },
            getVersion: function() {
              return l.STREAMSENSE_VERSION
            },
            addListener: function(a) {
              h.addListener(a)
            },
            removeListener: function(a) {
              h.removeListener(a)
            },
            getClip: function() {
              return console && console.warn && console.warn("getClip() is deprecated. Use getPlaylist().getClip() instead."), h.getSseSM().getPlaylist().getClip()
            },
            getPlaylist: function() {
              return h.getSseSM().getPlaylist()
            },
            setHttpGet: function(a) {
              "function" == typeof a && (h.getPlatformAPI().httpGet = a)
            },
            setHttpPost: function(a) {
              "function" == typeof a && (h.getPlatformAPI().httpPost = a)
            },
            setExitEndEventEnabled: function(a) {
              g = a
            },
            isExitEndEventEnabled: function() {
              return g
            },
            getPlatformAPI: function() {
              return h.getPlatformAPI()
            }
          }), b.extend(this, {
            customNotify: e,
            viewNotify: function(a, b) {
              a = a || k.getPixelURL(), a && viewNotify(a, b)
            }
          }), b.isBrowser() && (window.addEventListener ? (window.addEventListener("beforeunload", f), window.addEventListener("unload", f)) : window.attachEvent && (window.attachEvent("onbeforeunload", f), window.attachEvent("onunload", f))), d()
        }
      }();
    return function(c) {
      function d(a, b) {
        return x[z] || f(a, b)
      }

      function e() {
        z = -1;
        for (var b = 0; y >= b; b++)
          if (x.hasOwnProperty(String(b))) {
            z = b;
            break
          }
        return a.StreamSense.activeIndex = z, z
      }

      function f(b, c) {
        return b = b || null, c = c || null, b && "object" == typeof b && (c = b, b = null), x[++y] = new a.StreamSense(c, b), e(), x[y]
      }

      function g() {
        var b = !1,
          c = z;
        if ("number" == typeof arguments[0] && isFinite(arguments[0])) c = arguments[0];
        else if (arguments[0] instanceof a.StreamSense)
          for (var d in x)
            if (x.hasOwnProperty(d) && x[d] === arguments[0]) {
              c = d;
              break
            }
        return x.hasOwnProperty(String(c)) && (b = x[c], delete x[c], b.reset(), e()), b
      }

      function h(a) {
        return a = a || {}, d().setPlaylist(a), d().getPlaylist()
      }

      function i(a, b, c) {
        return a = a || {}, "number" == typeof b && (a.ns_st_cn = String(b)), d().setClip(a, c), d().getClip()
      }

      function j(a, b, c) {
        return "undefined" == typeof a ? !1 : (c = c || null, b = b || {}, d().notify(a, b, c))
      }

      function k(a) {
        "undefined" != typeof a && d().setLabels(a)
      }

      function l() {
        return d().getLabels()
      }

      function m(a) {
        "undefined" != typeof a && d().getPlaylist().setLabels(a)
      }

      function n() {
        return d().getPlaylist().getLabels()
      }

      function o(a) {
        "undefined" != typeof a && d().getClip().setLabels(a)
      }

      function p() {
        return d().getClip().getLabels()
      }

      function q(a) {
        return d().reset(a || {})
      }

      function r(a) {
        return d().getPlaylist().reset(a || {})
      }

      function s(a) {
        return d().getClip().reset(a || {})
      }

      function t(a) {
        return a = a || {}, d().viewNotify(null, a)
      }

      function u(a, b) {
        return arguments.length > 2 && (a = arguments[1], b = arguments[2]), a = a || {}, "number" == typeof b && (a.ns_st_po = String(b)), d().customNotify(a, b)
      }

      function v() {
        return d().exportState()
      }

      function w(a) {
        d().importState(a)
      }
      var x = {},
        y = -1,
        z = -1;
      b.extend(c, {
        activeIndex: z,
        newInstance: f,
        "new": f,
        destroyInstance: g,
        destroy: g,
        newPlaylist: h,
        newClip: i,
        notify: j,
        setLabels: k,
        getLabels: l,
        setPlaylistLabels: m,
        getPlaylistLabels: n,
        setClipLabels: o,
        getClipLabels: p,
        resetInstance: q,
        resetPlaylist: r,
        resetClip: s,
        viewEvent: t,
        customEvent: u,
        exportState: v,
        importState: w
      })
    }(H), H.PlayerEvents = i, H.InternalStates = j, H.ImplementationType = k, H
  }(), a.StreamingTag = a.StreamingTag || function() {
    var c = a.StreamSense,
      d = (a.StreamSense.PlayerEvents, a.StreamSense.InternalStates || null),
      e = a.StreamSense.ImplementationType || null,
      f = null != a.StreamSense.InternalStates && null != a.StreamSense.ImplementationType;
    return function() {
      var a = {
          LongFormOnDemand: "12",
          ShortFormOnDemand: "11",
          Live: "13",
          UserGeneratedLongFormOnDemand: "22",
          UserGeneratedShortFormOnDemand: "21",
          UserGeneratedLive: "23",
          Bumper: "99",
          Other: "00"
        },
        g = {
          LinearOnDemandPreRoll: "11",
          LinearOnDemandMidRoll: "12",
          LinearOnDemandPostRoll: "13",
          LinearLive: "21",
          Other: "00"
        },
        h = function(a) {
          function g() {
            if (f)
              if (b.getNamespace().comScore) q = new c, q.setImplementationType(e.REDUCED);
              else if (b.exists(a))
              if (r = b.isTrue(a.debug), b.exists(a.customerC2) && a.customerC2.length > 0) {
                var d = a.secure ? "https://sb" : "http" + ("s" == document.location.href.charAt(4) ? "s://sb" : "://b");
                q = new c, q.setPixelURL(d + ".scorecardresearch.com/p?c1=2"), q.setLabel("c2", a.customerC2), q.setImplementationType(e.REDUCED)
              } else r && console && console.log("Warning: customerC2 is not provided (or incorrect) in the StreamingTag configuration.")
          }

          function h(a) {
            b.exists(a) || (a = {});
            for (var c in t) t.hasOwnProperty(c) && !b.exists(a[t[c]]) && ("ns_st_ci" == t[c] ? a.ns_st_ci = "0" : a[t[c]] = "*null");
            return a
          }

          function i(a) {
            for (var b in t)
              if (t.hasOwnProperty(b) && !j(t[b], o, a)) return !1;
            return !0
          }

          function j(a, c, d) {
            if (b.exists(a) && b.exists(c) && b.exists(d)) {
              var e = c[a],
                f = d[a];
              return b.exists(e) && b.exists(f) && e === f
            }
            return !1
          }

          function k(a) {
            n++;
            var c = {
              ns_st_cn: String(n),
              ns_st_pn: "1",
              ns_st_tp: "0"
            };
            b.extend(c, a), q.setClip(c), o = a, q.play()
          }

          function l(a) {
            n++, a = h(a);
            var c = {
              ns_st_cn: String(n),
              ns_st_pn: "1",
              ns_st_tp: "1",
              ns_st_ad: "1"
            };
            b.extend(c, a), q.setClip(c), q.play(), p = !1
          }

          function m(a, b) {
            a = h(a), u == s.None && (u = b), p && u == b && i(a) ? (q.getClip().setLabels(a), q.getState() != d.PLAYING && q.play()) : k(a), p = !0, u = b
          }
          var n = 0,
            o = null,
            p = !1,
            q = null,
            r = !1,
            s = {
              None: 0,
              AudioContent: 1,
              VideoContent: 2
            },
            t = ["ns_st_ci", "c3", "c4", "c6", "ns_st_st", "ns_st_pu", "ns_st_pr", "ns_st_ep", "ns_st_sn", "ns_st_en", "ns_st_ct"],
            u = s.None;
          b.extend(this, {
            playAdvertisement: function() {
              if (q) {
                r && console && console.warn("Calling deprecated function 'playAdvertisement'. Please call 'playVideoAdvertisement' or 'playAudioAdvertisement' functions instead.");
                var a = {
                  ns_st_ct: "va"
                };
                l(a)
              }
            },
            playVideoAdvertisement: function(a, c) {
              if (q) {
                var d = {
                  ns_st_ct: "va"
                };
                c ? d.ns_st_ct = "va" + c : r && console && console.warn("Calling 'playVideoAdvertisement' without specifying the media type as a second parameter."), a && b.extend(d, a), l(d)
              }
            },
            playAudioAdvertisement: function(a, c) {
              if (q) {
                var d = {
                  ns_st_ct: "aa"
                };
                c ? d.ns_st_ct = "aa" + c : r && console && console.warn("Calling 'playAudioAdvertisement' without specifying the media type as a second parameter."), a && b.extend(d, a), l(d)
              }
            },
            playContentPart: function(a) {
              if (q) {
                r && console && console.warn("Calling deprecated function 'playContentPart'. Please call 'playVideoContentPart' or 'playAudioContentPart' functions instead.");
                var c = {
                  ns_st_ct: "vc"
                };
                a && b.extend(c, a), m(c, s.VideoContent)
              }
            },
            playVideoContentPart: function(a, c) {
              if (q) {
                var d = {
                  ns_st_ct: "vc"
                };
                c ? d.ns_st_ct = "vc" + c : r && console && console.warn("Calling 'playVideoContentPart' without specifying the media type as a second parameter."), a && b.extend(d, a), m(d, s.VideoContent)
              }
            },
            playAudioContentPart: function(a, c) {
              if (q) {
                var d = {
                  ns_st_ct: "ac"
                };
                c ? d.ns_st_ct = "ac" + c : r && console && console.warn("Calling 'playAudioContentPart' without specifying the media type as a second parameter."), a && b.extend(d, a), m(d, s.AudioContent)
              }
            },
            stop: function() {
              q && q.pause()
            }
          }), g()
        };
      return function(a) {}(h), h.ContentType = a, h.AdType = g, h
    }()
  }(), a
});


//////////////////
// WEBPACK FOOTER
// ./src/comscore.js
// module id = 176
// module chunks = 0